import { MenuItem, Select, TextField, Typography, FormControl } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
// import { indigo } from '@material-ui/core/colors';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
// import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actionTypes from '../../../store/NewPatient/actionType';
import { withLang } from '../../../util/lang';
import { getWebAbsPath } from '../../../util/path';
import styles from './NewPatientPrescriptionNotes.module.css';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import NewErrorMessageDialog from '../../Dialog/NewErrorMessageDialog';
import ErrorIcon from '@material-ui/icons/Error';
import Tooltip from '@material-ui/core/Tooltip';
import { styled } from '@material-ui/core/styles';
import PatientCurrentStepInput from './PatientCurrentStepInput';
import { FORM_TYPE } from './type';
import TrioDimDialog from '../TrioDimDialog/TrioDimDialog';
import SmileDesignReportDialog from '../SmileDesignReportDialog/SmileDesignReportDialog';
import { alignerPrescriptionFormValidation } from '../../../util/alignerPrescriptionFormHelper';
import { getPrescriptionNotesQuestions, renderToothMarkers, shouldShowUpsellForm } from '../NewPatientUtill';
import RestorativeOptions from './RestorativeOptions/RestorativeOptions';
import PreImplantAligment from './PreImplantAligment/PreImplantAligment';
import AddOnSmileDesign from './AddOnSmileDesign/AddOnSmileDesign';
import ExpandingGrid from '../ExpandingGrid/ExpandingGrid';
import ExpandingModal from '../ExpandingModal/ExpandingModal';
import { initialState } from '../../../store/NewPatient/NewPatient.reducer';
import _ from 'lodash';
import { openModal } from '../../../store/Global/global';
import SubOptCheckBoxLabel from './SubOptCheckBoxLabel/SubOptCheckBoxLabel';

const RedTextField = styled(TextField)({
    '& label': {
        color: 'rgba(147,147,147,255) !important',
    },
    '& label.Mui-focused': {
        color: 'rgba(147,147,147,255) !important',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'rgba(147,147,147,255) !important',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'red !important',
        },
        '&:hover fieldset': {
            borderColor: 'red !important',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'red !important',
        },
    },
});

// const IndigoCheckbox = withStyles({
//     root: {
//         color: indigo[500],
//         '&$checked': {
//             color: indigo[600],
//         },
//     },
//     checked: {},
// })((props) => <Checkbox color="default" {...props} />);

class PrescriptionNotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            errorFrom: '',
            trioDimModalOpen: false,
            expandingModalOpen: false,
            expandingModalChildrenFunc: null,
            smileDesignReportModalOpen: false,
        };
        this.changeState = this.changeState.bind(this);
        this.getNotes = this.getNotes.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleDialog = this.handleDialog.bind(this);
        this.getWarning = this.getWarning.bind(this);

        this.specialInstructionsRef = React.createRef();
        this.formType = props.formType || null;
    }

    getNotes = (title) => {
        return this.get(`prescriptionNotes.${title}`);
    };

    getWarning = (title) => {
        return this.get(`warning.${title}`);
    };

    isShowUpsellForm = () => {
        const { allowedFeatures } = this.props.userAllowedFeatures || {};
        return shouldShowUpsellForm(allowedFeatures, this.formType);
    };

    handleClick = (e, func) => {
        const { left, top } = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;

        for (let [_, objValue] of Object.entries(this.teeth)) {
            if (x > objValue.maxX || x < objValue.minX || y > objValue.maxY || y < objValue.minY) continue;
            for (let i = 0; i < objValue.values.length; i++) {
                const { value, boundX } = objValue.values[i];
                if (boundX < x) continue;
                func(value);
                break;
            }
            break;
        }
    };
    // for validating if the tooth already selected in the other attachment diagram, if yes(true), show modal
    validateAttachmentsOnTeeth = (e, targetField) => {
        const { left, top } = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;
        const { place, doNotPlace } = this.props.attachments;
        let selectedTeeth = [];
        if (targetField === 'includedAttachments') {
            selectedTeeth = [...place];
        } else {
            selectedTeeth = [...doNotPlace];
        }
        let teethValue = undefined;
        for (let [_, objValue] of Object.entries(this.teeth)) {
            if (x > objValue.maxX || x < objValue.minX || y > objValue.maxY || y < objValue.minY) continue;
            for (let i = 0; i < objValue.values.length; i++) {
                const { value, boundX } = objValue.values[i];
                if (boundX < x) continue;
                teethValue = value;
                break;
            }
            break;
        }
        if (teethValue) {
            if (selectedTeeth.includes(teethValue)) return true;
        }
        return false;
    };

    getAttactmentModalContent = () => {
        return {
            modalTitle: this.get('@global.const.actionRequired'),
            modalMessage: this.getNotes('teethAttachmentContradiction'),
        };
    };
    componentDidUpdate(prevProps, prevState) {
        if (this.props.prescriptionScroll === true) {
            setTimeout(() => {
                this.handleClickScroll(this.props.prescriptionScrollToId);
            }, 500);
            this.props.handlePrescriptionErrorScroll();
        }

        if (prevProps.posteriorCrossbite.subValue.value !== this.props.posteriorCrossbite.subValue.value) {
            this.setState({ otherMethodTmp: this.props.posteriorCrossbite.subValue.subValue.otherMethod });
        }

        if (prevProps.auxiliaries.otherElastics.value !== this.props.auxiliaries.otherElastics.value) {
            this.setState({ otherElasticsCommentTmp: this.props.auxiliaries.otherElastics.comment });
        }
    }

    changeState = (field, value) => {
        this.setState((state) => ({
            ...state,
            [field]: value,
        }));
    };

    handleClickScroll = (id) => {
        const element = document.getElementById(id);
        console.log('element => ', element);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    handleDialog = () => {
        this.changeState('dialogOpen', !this.state.dialogOpen);
    };

    validation = (value) => {
        const {
            attachments,
            spacingAndCrowding,
            openbite,
            deepBite,
            midline,
            posteriorCrossbite,
            auxiliaries,
            restorativeOptions,
            archToTreat,
            anteriorPosteriorRelationship,
        } = this.props;
        const {
            condition1,
            condition3,
            condition4,
            condition5,
            condition6,
            condition7,
            condition8,
            condition9,
            condition10,
            condition11,
            condition12,
            condition13,
            condition14,
            condition16,
            condition17,
            // restorativeOptionsSubValueErr
        } = alignerPrescriptionFormValidation(
            {
                archToTreat,
                anteriorPosteriorRelationship,
                attachments,
                spacingAndCrowding,
                openbite,
                deepBite,
                midline,
                posteriorCrossbite,
                auxiliaries,
                restorativeOptions,
            },
            value
        );

        if (condition1) {
            this.props.handlePrescriptionErrorQuestion(1);
            this.props.handlePrescriptionErrorScrollId('Q3');
        }
        //else if (condition2) {
        //this.props.handlePrescriptionErrorQuestion(2);
        //this.props.handlePrescriptionErrorScrollId('Q3');
        else if (condition3) {
            this.props.handlePrescriptionErrorQuestion(3);
            this.props.handlePrescriptionErrorScrollId('Q3');
        } else if (condition4) {
            this.props.handlePrescriptionErrorQuestion(4);
            this.props.handlePrescriptionErrorScrollId('Q6');
        } else if (condition5) {
            this.props.handlePrescriptionErrorQuestion(5);
            this.props.handlePrescriptionErrorScrollId('Q8');
        } else if (condition6) {
            this.props.handlePrescriptionErrorQuestion(6);
            this.props.handlePrescriptionErrorScrollId('Q8');
        } else if (condition7) {
            this.props.handlePrescriptionErrorQuestion(7);
            this.props.handlePrescriptionErrorScrollId('Q8');
        } else if (condition9) {
            this.props.handlePrescriptionErrorQuestion(9);
            this.props.handlePrescriptionErrorScrollId('Q9');
        } else if (condition8) {
            this.props.handlePrescriptionErrorQuestion(8);
            this.props.handlePrescriptionErrorScrollId('Q9');
        } else if (condition10) {
            this.props.handlePrescriptionErrorQuestion(10);
            this.props.handlePrescriptionErrorScrollId('Q9');
        } else if (condition12) {
            this.props.handlePrescriptionErrorQuestion(12);
            this.props.handlePrescriptionErrorScrollId('Q10');
        } else if (condition11) {
            this.props.handlePrescriptionErrorQuestion(11);
            this.props.handlePrescriptionErrorScrollId('Q10');
        } else if (condition16) {
            this.props.handlePrescriptionErrorQuestion(16);
            this.props.handlePrescriptionErrorScrollId('Q11');
        } else if (condition13) {
            this.props.handlePrescriptionErrorQuestion(13);
            this.props.handlePrescriptionErrorScrollId('Q11');
        } else if (condition17) {
            this.props.handlePrescriptionErrorQuestion(17);
            this.props.handlePrescriptionErrorScrollId('Q11');
        } else if (condition14) {
            this.props.handlePrescriptionErrorQuestion(14);
            this.props.handlePrescriptionErrorScrollId('Q12');
        }

        if (condition1) {
            this.props.handlePrescriptionError(this.getWarning('tooth'));
            this.changeState('errorFrom', value);
            this.handleDialog();
            return false;
        } else if (condition3) {
            this.props.handlePrescriptionError(this.getWarning('value'));
            this.changeState('errorFrom', value);
            this.handleDialog();
            return false;
        } else if (condition4) {
            this.props.handlePrescriptionError(this.getWarning('locationOfTheSpace'));
            this.changeState('errorFrom', value);
            this.handleDialog();
            return false;
        } else if (condition5 || condition6 || condition8 || condition9 || condition13 || condition16) {
            this.props.handlePrescriptionError(this.getWarning('checkbox'));
            this.changeState('errorFrom', value);
            this.handleDialog();
            return false;
        } else if (condition7 || condition10) {
            this.props.handlePrescriptionError(this.getWarning('specifyArea'));
            this.changeState('errorFrom', value);
            this.handleDialog();
            return false;
        } else if (condition11 || condition12) {
            this.props.handlePrescriptionError(this.getWarning('option'));
            this.changeState('errorFrom', value);
            this.handleDialog();
            return false;
        } else if (condition14) {
            this.props.handlePrescriptionError(this.getNotes('otherElasticsHintText'));
            this.changeState('errorFrom', value);
            this.handleDialog();
            return false;
        } else if (condition17) {
            this.props.handlePrescriptionError(this.getWarning('otherMethods'));
            this.changeState('errorFrom', value);
            this.handleDialog();
            return false;
        } else {
            this.props.handlePrescriptionError();
            this.changeState('errorFrom', '');
            this.props.handlePrescriptionErrorScrollId('');
            this.setState({ error: 0 });
            return true;
        }
    };

    get questions() {
        return getPrescriptionNotesQuestions(this.getNotes);
    }

    handleExpandingModalOpen = (questionId) => {
        const factoryFunc = this.createQuestionContentFunction(questionId);
        this.setState({ expandingModalOpen: true, expandingModalChildrenFunc: factoryFunc });
    };

    teeth = {
        topRight: {
            maxX: 590,
            maxY: 80,
            minX: 50,
            minY: 20,
            values: [
                {
                    value: 0,
                    positionX: 90,
                    positionY: 50,
                    boundX: 130,
                },
                {
                    value: 1,
                    positionX: 170,
                    positionY: 50,
                    boundX: 210,
                },
                {
                    value: 2,
                    positionX: 255,
                    positionY: 50,
                    boundX: 300,
                },
                {
                    value: 3,
                    positionX: 330,
                    positionY: 50,
                    boundX: 365,
                },
                {
                    value: 4,
                    positionX: 400,
                    positionY: 50,
                    boundX: 430,
                },
                {
                    value: 5,
                    positionX: 460,
                    positionY: 50,
                    boundX: 482,
                },
                {
                    value: 6,
                    positionX: 510,
                    positionY: 50,
                    boundX: 540,
                },
                {
                    value: 7,
                    positionX: 565,
                    positionY: 50,
                    boundX: 590,
                },
            ],
        },
        topLeft: {
            maxX: 1130,
            maxY: 80,
            minX: 590,
            minY: 20,
            values: [
                {
                    value: 8,
                    positionX: 620,
                    positionY: 50,
                    boundX: 650,
                },
                {
                    value: 9,
                    positionX: 670,
                    positionY: 50,
                    boundX: 700,
                },
                {
                    value: 10,
                    positionX: 725,
                    positionY: 50,
                    boundX: 750,
                },
                {
                    value: 11,
                    positionX: 780,
                    positionY: 50,
                    boundX: 820,
                },
                {
                    value: 12,
                    positionX: 850,
                    positionY: 50,
                    boundX: 885,
                },
                {
                    value: 13,
                    positionX: 928,
                    positionY: 50,
                    boundX: 970,
                },
                {
                    value: 14,
                    positionX: 1010,
                    positionY: 50,
                    boundX: 1050,
                },
                {
                    value: 15,
                    positionX: 1092,
                    positionY: 50,
                    boundX: 1130,
                },
            ],
        },
        bottomRight: {
            maxX: 590,
            maxY: 250,
            minX: 50,
            minY: 180,
            values: [
                {
                    value: 16,
                    positionX: 90,
                    positionY: 220,
                    boundX: 130,
                },
                {
                    value: 17,
                    positionX: 170,
                    positionY: 220,
                    boundX: 210,
                },
                {
                    value: 18,
                    positionX: 255,
                    positionY: 220,
                    boundX: 300,
                },
                {
                    value: 19,
                    positionX: 330,
                    positionY: 220,
                    boundX: 365,
                },
                {
                    value: 20,
                    positionX: 400,
                    positionY: 220,
                    boundX: 430,
                },
                {
                    value: 21,
                    positionX: 460,
                    positionY: 220,
                    boundX: 482,
                },
                {
                    value: 22,
                    positionX: 510,
                    positionY: 220,
                    boundX: 540,
                },
                {
                    value: 23,
                    positionX: 565,
                    positionY: 220,
                    boundX: 590,
                },
            ],
        },
        bottomLeft: {
            maxX: 1130,
            maxY: 250,
            minX: 590,
            minY: 180,
            values: [
                {
                    value: 24,
                    positionX: 620,
                    positionY: 220,
                    boundX: 650,
                },
                {
                    value: 25,
                    positionX: 670,
                    positionY: 220,
                    boundX: 700,
                },
                {
                    value: 26,
                    positionX: 725,
                    positionY: 220,
                    boundX: 750,
                },
                {
                    value: 27,
                    positionX: 780,
                    positionY: 220,
                    boundX: 820,
                },
                {
                    value: 28,
                    positionX: 850,
                    positionY: 220,
                    boundX: 885,
                },
                {
                    value: 29,
                    positionX: 928,
                    positionY: 220,
                    boundX: 970,
                },
                {
                    value: 30,
                    positionX: 1010,
                    positionY: 220,
                    boundX: 1050,
                },
                {
                    value: 31,
                    positionX: 1092,
                    positionY: 220,
                    boundX: 1130,
                },
            ],
        },
    };

    createQuestionContentFunction = (questionId) => {
        let func = () => null;
        switch (questionId) {
            case 'Q1':
                func = () => (
                    <>
                        <ol start={1}>
                            <li>{this.getNotes('archToTreat')}</li>
                        </ol>
                        <RadioGroup
                            row
                            name="archToTreat"
                            value={this.props.archToTreat}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('archToTreat')) return;
                                this.props.handleDataArchToTreat(e.target.value);
                            }}
                        >
                            {this.questions.archToTreat.options.map(({ label, value }, i) => (
                                <div key={i + value}>
                                    <FormControlLabel
                                        style={{ width: 'fit-content' }}
                                        label={label}
                                        value={value}
                                        control={<Radio />}
                                    />
                                    {this.props.formType === FORM_TYPE.REFINEMENT &&
                                        this.props.archToTreat === value && (
                                            <PatientCurrentStepInput
                                                mode={this.props.mode}
                                                archToTreat={this.props.archToTreat}
                                                value={{
                                                    archToTreatUpperStep: this.props.archToTreatStep.upper,
                                                    archToTreatLowerStep: this.props.archToTreatStep.lower,
                                                }}
                                            />
                                        )}
                                </div>
                            ))}
                        </RadioGroup>
                    </>
                );
                return func;
            case 'Q2':
                func = () => (
                    <div>
                        <ol start={2}>
                            {localStorage.lang === 'English' || localStorage.lang === 'en' ? (
                                <li>
                                    {this.getNotes('excludedDentition').split('NOT')[0]}
                                    <span className={[styles.redText, styles.underline].join(' ')}>NOT</span>
                                    {this.getNotes('excludedDentition').split('NOT')[1]}
                                </li>
                            ) : (
                                <li id="Q2">{this.getNotes('excludedDentition')}</li>
                            )}
                        </ol>
                        <div className={styles.toothImages}>
                            <div
                                style={{
                                    width: 1175,
                                    height: 300,
                                    'margin-top': '10px',
                                    position: 'relative',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/teeth_number_CS6.ai.png')}")`,
                                }}
                                onClick={(e) => {
                                    if (this.props.readOnly) return;
                                    if (!this.validation('excludedDentition')) return;
                                    console.log('e', e);
                                    console.log('this.props.handleDataNotToTreat', this.props.handleDataNotToTreat);
                                    this.handleClick(e, this.props.handleDataNotToTreat);
                                }}
                            >
                                {renderToothMarkers(
                                    this.props.notToTreat,
                                    this.teeth,
                                    '/img/prescriptionNotes/checkFail.png'
                                )}
                            </div>
                        </div>
                    </div>
                );
                return func;
            case 'Q3':
                func = () => (
                    <div>
                        <ol start={3}>
                            <li className="field_label" data-mandatory={true}>
                                {this.questions.attachments.label}
                            </li>
                        </ol>
                        <RadioGroup
                            name="attachments"
                            value={this.props.attachments.value}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('attachments')) return;
                                this.props.handleAttachements(e.target.value);
                            }}
                        >
                            {this.questions.attachments.options.map((opt) => {
                                let labelNode = opt.label;
                                if (opt.value === 'includedExcludedAttachments') {
                                    const isEng = localStorage.lang === 'English' || localStorage.lang === 'en';
                                    if (isEng) {
                                        labelNode = (
                                            <Typography>
                                                {this.getNotes('includedExcludedAttachments').split('NOT')[0]}
                                                <span className={[styles.redText, styles.underline].join(' ')}>
                                                    NOT
                                                </span>
                                                {this.getNotes('includedExcludedAttachments').split('NOT')[1]}
                                            </Typography>
                                        );
                                    }
                                }
                                return (
                                    <>
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={opt.value}
                                            control={<Radio />}
                                            label={labelNode}
                                        />
                                        {opt?.helperText?.length > 0 && (
                                            <strong style={{ marginLeft: 32, fontSize: 14 }}>{opt.helperText}</strong>
                                        )}
                                    </>
                                );
                            })}
                            {this.props.attachments.value === 'includedExcludedAttachments' ? (
                                <>
                                    {this.getNotes('excludedAttachments')}
                                    <div style={{ display: 'flex' }}>
                                        <div className={styles.toothImages} tabIndex="0">
                                            <div
                                                style={{
                                                    width: 1175,
                                                    height: 300,
                                                    'margin-top': '10px',
                                                    position: 'relative',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/teeth_number_CS6.ai.png')}")`,
                                                    backgroundColor:
                                                        this.props.attachments.value ===
                                                            'includedExcludedAttachments' &&
                                                        this.props.attachments.doNotPlace.length === 0 &&
                                                        this.props.prescriptionError &&
                                                        this.props.prescriptionErrorQuestion === 1
                                                            ? '#faff78'
                                                            : null,
                                                }}
                                                onClick={(e) => {
                                                    if (this.props.readOnly) return;
                                                    if (!this.validation('attachments')) return;
                                                    if (this.validateAttachmentsOnTeeth(e, 'includedAttachments')) {
                                                        this.props.openGlobalModal(this.getAttactmentModalContent());
                                                        return;
                                                    }
                                                    this.handleClick(e, this.props.handleAttachementsClickNotToPlace);
                                                }}
                                            >
                                                {renderToothMarkers(
                                                    this.props.attachments.doNotPlace,
                                                    this.teeth,
                                                    '/img/prescriptionNotes/checkFail.png'
                                                )}
                                            </div>
                                        </div>
                                        {this.props.attachments.value === 'includedExcludedAttachments' &&
                                            this.props.attachments.doNotPlace.length === 0 &&
                                            this.props.attachments.place.length === 0 && (
                                                <div>
                                                    <Tooltip title={this.getNotes('attachmentTooltip')}>
                                                        <ErrorIcon style={{ color: 'red' }} />
                                                    </Tooltip>
                                                </div>
                                            )}
                                    </div>
                                </>
                            ) : null}
                            {this.props.attachments.value === 'includedExcludedAttachments' ? (
                                <>
                                    {this.getNotes('includedAttachments')}
                                    <div style={{ display: 'flex' }}>
                                        <div className={styles.toothImages}>
                                            <div
                                                style={{
                                                    width: 1175,
                                                    height: 300,
                                                    'margin-top': '10px',
                                                    position: 'relative',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/teeth_number_CS6.ai.png')}")`,
                                                    backgroundColor:
                                                        this.props.attachments.value ===
                                                            'includedExcludedAttachments' &&
                                                        this.props.attachments.place.length === 0 &&
                                                        this.props.prescriptionError &&
                                                        this.props.prescriptionErrorQuestion === 2
                                                            ? '#faff78'
                                                            : null,
                                                }}
                                                onClick={(e) => {
                                                    if (this.props.readOnly) return;
                                                    if (!this.validation('attachments')) return;
                                                    if (this.validateAttachmentsOnTeeth(e, 'excludedAttachments')) {
                                                        this.props.openGlobalModal(this.getAttactmentModalContent());
                                                        return;
                                                    }
                                                    this.handleClick(e, this.props.handleAttachementsClickPlace);
                                                }}
                                            >
                                                {renderToothMarkers(
                                                    this.props.attachments.place,
                                                    this.teeth,
                                                    '/img/prescriptionNotes/checkSuccess.png'
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </RadioGroup>
                        <p className="field_label" data-mandatory={true}>
                            {this.questions.attachmentsDelayStage.label}
                        </p>
                        <RadioGroup
                            name="attachmentsDelayStage"
                            value={this.props.attachments.delay.value}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('attachments')) return;
                                this.props.handleAttachementsClickDelay(e.target.value);
                            }}
                        >
                            <FormControlLabel
                                style={{ width: 'fit-content' }}
                                value={this.questions.attachmentsDelayStage.options[0].value}
                                control={<Radio />}
                                label={this.questions.attachmentsDelayStage.options[0].label}
                            />
                            <div className={styles.delay}>
                                <FormControlLabel
                                    style={{ width: 'fit-content' }}
                                    value={this.questions.attachmentsDelayStage.options[1].value}
                                    control={<Radio />}
                                    label={this.questions.attachmentsDelayStage.options[1].label}
                                />
                                <FormControl>
                                    <Select
                                        value={this.props.attachments.delay.stage}
                                        onChange={(e) => {
                                            if (this.props.readOnly) return;
                                            if (!this.validation('attachments')) return;
                                            this.props.handleAttachementsClickDelayStage(e.target.value);
                                        }}
                                        displayEmpty
                                        disabled={
                                            this.props.attachments.delay.value ===
                                            this.questions.attachmentsDelayStage.options[0].value
                                        }
                                        style={{
                                            width: '60px',
                                            height: '40px',
                                            marginLeft: '10px',
                                            backgroundColor:
                                                this.props.attachments.delay.value === 'delayToStage' &&
                                                !this.props.attachments.delay.stage &&
                                                this.props.prescriptionError &&
                                                this.props.prescriptionErrorQuestion === 3
                                                    ? '#faff78'
                                                    : null,
                                        }}
                                    >
                                        {this.questions.attachmentsDelayStage.menu.map((stage) => {
                                            if (stage === '--') return <MenuItem value={''}>{stage}</MenuItem>;

                                            return <MenuItem value={stage}>{stage}</MenuItem>;
                                        })}
                                    </Select>
                                </FormControl>
                                {this.props.attachments.delay.value === 'delayToStage' &&
                                    !this.props.attachments.delay.stage && (
                                        <Tooltip title={this.getNotes('requiredInformation')}>
                                            <ErrorIcon style={{ color: 'red' }} />
                                        </Tooltip>
                                    )}
                            </div>
                        </RadioGroup>
                    </div>
                );
                return func;
            case 'Q4':
                func = () => (
                    <ol start={4}>
                        <li>{this.questions.alignersMarginPlacement.label}</li>
                        <RadioGroup
                            name="alignersMarginPlacement"
                            value={this.props.alignersMarginPlacement}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('alignersMarginPlacement')) return;
                                this.props.handleMarginPlacement(e.target.value);
                            }}
                        >
                            {this.questions.alignersMarginPlacement.options.map(({ value, label }, i) => {
                                return (
                                    <FormControlLabel
                                        style={{ width: 'fit-content' }}
                                        value={value}
                                        control={<Radio />}
                                        label={label}
                                        key={i + value}
                                    />
                                );
                            })}
                        </RadioGroup>
                    </ol>
                );
                return func;
            case 'Q5':
                func = () => {
                    const currentR = this.props.anteriorPosteriorRelationship.r;
                    const currentL = this.props.anteriorPosteriorRelationship.l;
                    const isImproveR = currentR && currentR !== 'maintain';
                    const isImproveL = currentL && currentL !== 'maintain';
                    const subOptions = this.questions.anteriorPosteriorRelationship.options.filter(
                        (o) => o.value !== 'maintain'
                    );
                    const mainValueR = currentR === 'maintain' ? 'maintain' : currentR ? 'improveRelationship' : null;
                    const mainValueL = currentL === 'maintain' ? 'maintain' : currentL ? 'improveRelationship' : null;
                    const showErrorR = currentR === 'improveRelationship';
                    const showErrorL = currentL === 'improveRelationship';

                    return (
                        <>
                            <ol start={5}>
                                <li>{this.questions.anteriorPosteriorRelationship.label}</li>
                            </ol>
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '500px 40px 60px 60px 30px',
                                    alignItems: 'center',
                                }}
                            >
                                <div></div>
                                <div></div>
                                <FormLabel style={{ textAlign: 'center' }}>{this.getNotes('right')}</FormLabel>
                                <FormLabel style={{ textAlign: 'center' }}>{this.getNotes('left')}</FormLabel>
                                <div></div>
                                <span>{this.getNotes('maintain')}</span>
                                <div></div>
                                <RadioGroup
                                    row
                                    style={{ justifyContent: 'center' }}
                                    value={mainValueR}
                                    onChange={(e) => {
                                        if (this.props.readOnly) return;
                                        if (!this.validation('anteriorPosteriorRelationship')) return;
                                        if (e.target.value === 'maintain') {
                                            this.props.handleApRelationships('maintain', 'r');
                                        } else {
                                            this.props.handleApRelationships('improveRelationship', 'r');
                                        }
                                    }}
                                >
                                    <FormControlLabel
                                        value="maintain"
                                        control={<Radio />}
                                        key="maintainR"
                                        style={{ margin: 0 }}
                                    />
                                </RadioGroup>
                                <RadioGroup
                                    row
                                    style={{ justifyContent: 'center' }}
                                    value={mainValueL}
                                    onChange={(e) => {
                                        if (this.props.readOnly) return;
                                        if (!this.validation('anteriorPosteriorRelationship')) return;
                                        if (e.target.value === 'maintain') {
                                            this.props.handleApRelationships('maintain', 'l');
                                        } else {
                                            this.props.handleApRelationships('improveRelationship', 'l');
                                        }
                                    }}
                                >
                                    <FormControlLabel
                                        value="maintain"
                                        control={<Radio />}
                                        key="maintainL"
                                        style={{ margin: 0 }}
                                    />
                                </RadioGroup>
                                <div></div>
                                <span>{this.getNotes('improveRelationship')}</span>
                                <div></div>
                                <RadioGroup
                                    row
                                    style={{ justifyContent: 'center' }}
                                    value={mainValueR}
                                    onChange={(e) => {
                                        if (this.props.readOnly) return;
                                        if (!this.validation('anteriorPosteriorRelationship')) return;
                                        if (e.target.value === 'maintain') {
                                            this.props.handleApRelationships('maintain', 'r');
                                        } else {
                                            this.props.handleApRelationships('improveRelationship', 'r');
                                        }
                                    }}
                                >
                                    <FormControlLabel
                                        value="improveRelationship"
                                        control={<Radio />}
                                        key="improveRelationshipR"
                                        style={{ margin: 0 }}
                                    />
                                </RadioGroup>
                                <RadioGroup
                                    row
                                    style={{ justifyContent: 'center' }}
                                    value={mainValueL}
                                    onChange={(e) => {
                                        if (this.props.readOnly) return;
                                        if (!this.validation('anteriorPosteriorRelationship')) return;
                                        if (e.target.value === 'maintain') {
                                            this.props.handleApRelationships('maintain', 'l');
                                        } else {
                                            this.props.handleApRelationships('improveRelationship', 'l');
                                        }
                                    }}
                                >
                                    <FormControlLabel
                                        value="improveRelationship"
                                        control={<Radio />}
                                        key="improveRelationshipL"
                                        style={{ margin: 0 }}
                                    />
                                </RadioGroup>
                                {(showErrorL || showErrorR) && <ErrorIcon style={{ color: 'red' }} />}
                            </div>
                            {(isImproveR || isImproveL) && (
                                <div
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: '500px 40px 60px 60px',
                                        alignItems: 'center',
                                        paddingTop: 8,
                                    }}
                                >
                                    {subOptions.map(({ label, value }) => (
                                        <React.Fragment key={value}>
                                            <span style={{ marginLeft: 20 }}>{label}</span>
                                            <div></div>
                                            {isImproveR ? (
                                                <RadioGroup
                                                    row
                                                    style={{ justifyContent: 'center' }}
                                                    value={currentR}
                                                    onChange={(e) => {
                                                        if (this.props.readOnly) return;
                                                        if (!this.validation('anteriorPosteriorRelationship')) return;
                                                        this.props.handleApRelationships(e.target.value, 'r');
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value={value}
                                                        control={<Radio />}
                                                        style={{ margin: 0 }}
                                                    />
                                                </RadioGroup>
                                            ) : (
                                                <div></div>
                                            )}
                                            {isImproveL ? (
                                                <RadioGroup
                                                    row
                                                    style={{ justifyContent: 'center' }}
                                                    value={currentL}
                                                    onChange={(e) => {
                                                        if (this.props.readOnly) return;
                                                        if (!this.validation('anteriorPosteriorRelationship')) return;
                                                        this.props.handleApRelationships(e.target.value, 'l');
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value={value}
                                                        control={<Radio />}
                                                        style={{ margin: 0 }}
                                                    />
                                                </RadioGroup>
                                            ) : (
                                                <div></div>
                                            )}
                                            
                                        </React.Fragment>
                                    ))}
                                </div>
                            )}
                        </>
                    );
                };
                return func;
            case 'Q6':
                func = () => {
                    const upperFields = [
                        'expand',
                        'procline',
                        'IPRAnterior',
                        'IPRPosteriorRight',
                        'IPRPosteriorLeft',
                        'extraction',
                    ];
                    const lowerFields = [
                        'expand',
                        'procline',
                        'IPRAnterior',
                        'IPRPosteriorRight',
                        'IPRPosteriorLeft',
                        'extraction',
                    ];
                    const isResolveUpper = upperFields.some(
                        (field) =>
                            this.props.spacingAndCrowding.crowding.resolveUpper[field]?.value &&
                            this.props.spacingAndCrowding.crowding.resolveUpper[field]?.value !== 'none'
                    );
                    const isResolveLower = lowerFields.some(
                        (field) =>
                            this.props.spacingAndCrowding.crowding.resolveLower[field]?.value &&
                            this.props.spacingAndCrowding.crowding.resolveLower[field]?.value !== 'none'
                    );

                    const handleToggleResolve = (category, isSelected) => {
                        const fields = category === 'resolveUpper' ? upperFields : lowerFields;
                        fields.forEach((field) => {
                            const newValue = isSelected && field !== 'extraction' ? 'asNeeded' : 'none';
                            this.props.handleCrowding(newValue, category, field);
                        });
                    };

                    return (
                        <>
                            <ol start={6}>
                                <li>{this.questions.spacingAndCrowding.label}</li>
                            </ol>
                            <div className={'field_label'} data-mandatory={true}>
                                <FormLabel className={styles.subtitle}>
                                    {this.questions.spacingAndCrowding.options[0].label}
                                </FormLabel>
                            </div>
                            <RadioGroup
                                row
                                value={this.props.spacingAndCrowding.spacing.value}
                                onChange={(e) => {
                                    if (this.props.readOnly) return;
                                    if (!this.validation('spacing')) return;
                                    this.props.handleSpacing(e.target.value);
                                }}
                            >
                                <div className={styles.radioButtons}>
                                    {this.questions.spacingAndCrowding.options[0].options.map(({ label, value }, i) => {
                                        return (
                                            <FormControlLabel
                                                value={value}
                                                control={<Radio />}
                                                label={label}
                                                key={i + value}
                                                style={{ width: 'fit-content' }}
                                            />
                                        );
                                    })}
                                </div>
                            </RadioGroup>
                            {this.props.spacingAndCrowding.spacing.value === 'leaveSpecificSpaces' ? (
                                <div>
                                    {!this.props.spacingAndCrowding.spacing.location ? (
                                        <>
                                            <RedTextField
                                                id="Q6TextField"
                                                defaultValue={this.props.spacingAndCrowding.spacing.location}
                                                label={this.getNotes('locationOfTheSpacesYouWantToLeaveOpen')}
                                                onBlur={(e) => {
                                                    if (!this.validation('spacing')) return;
                                                    this.props.handleSpacingLocation(e.target.value);
                                                }}
                                                onClick={() => {
                                                    if (!this.validation('spacing')) {
                                                        document.getElementById('Q6TextField').blur();
                                                    }
                                                }}
                                                style={{
                                                    width: 400,
                                                    marginLeft: 350,
                                                    marginTop: 20,
                                                    backgroundColor:
                                                        this.props.spacingAndCrowding.spacing.value ===
                                                            'leaveSpecificSpaces' &&
                                                        !this.props.spacingAndCrowding.spacing.location &&
                                                        this.props.prescriptionError &&
                                                        this.props.prescriptionErrorQuestion === 4
                                                            ? '#faff78'
                                                            : null,
                                                }}
                                                variant="outlined"
                                                inputProps={{ maxLength: 100 }}
                                                multiline
                                                rows="3"
                                                disabled={this.props.mode === 'view'}
                                            />
                                            <Tooltip title={this.getNotes('requiredInformation')}>
                                                <ErrorIcon style={{ color: 'red' }} />
                                            </Tooltip>
                                        </>
                                    ) : (
                                        <TextField
                                            id="Q6TextField"
                                            defaultValue={this.props.spacingAndCrowding.spacing.location}
                                            label={this.getNotes('locationOfTheSpacesYouWantToLeaveOpen')}
                                            onBlur={(e) => {
                                                if (!this.validation('spacing')) return;
                                                this.props.handleSpacingLocation(e.target.value);
                                            }}
                                            onClick={() => {
                                                if (!this.validation('spacing')) {
                                                    document.getElementById('Q6TextField').blur();
                                                }
                                            }}
                                            style={{
                                                width: 400,
                                                marginLeft: 350,
                                                marginTop: 20,
                                                backgroundColor:
                                                    this.props.spacingAndCrowding.spacing.value ===
                                                        'leaveSpecificSpaces' &&
                                                    !this.props.spacingAndCrowding.spacing.location &&
                                                    this.props.prescriptionError &&
                                                    this.props.prescriptionErrorQuestion === 4
                                                        ? '#faff78'
                                                        : null,
                                            }}
                                            variant="outlined"
                                            inputProps={{ maxLength: 100 }}
                                            multiline
                                            rows="3"
                                            disabled={this.props.mode === 'view'}
                                        />
                                    )}
                                </div>
                            ) : null}

                            <div className={'field_label'} data-mandatory={true}>
                                <FormLabel className={styles.subtitle}>
                                    {this.questions.spacingAndCrowding.options[1].label}
                                </FormLabel>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 15,
                                    marginTop: 10,
                                    marginLeft: 20,
                                }}
                            >
                                <div
                                    style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                    onClick={() => {
                                        if (this.props.readOnly) return;
                                        handleToggleResolve('resolveUpper', !isResolveUpper);
                                    }}
                                >
                                    <Radio
                                        checked={isResolveUpper}
                                        style={{ color: isResolveUpper ? '#3f51b5' : undefined }}
                                    />
                                    <span style={{ fontWeight: 'bold' }}>{this.getNotes('resolveUpper')}</span>
                                </div>
                                {isResolveUpper && (
                                    <div className={styles.subClass} style={{ marginLeft: 20 }}>
                                        {this.questions.spacingAndCrowding.options[1].options[0].options.map(
                                            ({ value, label }, i) => {
                                                return (
                                                    <div key={i + value}>
                                                        <RadioGroup
                                                            row
                                                            className={styles.row}
                                                            value={
                                                                this.props.spacingAndCrowding.crowding.resolveUpper[
                                                                    value
                                                                ]?.value
                                                            }
                                                            onChange={(e) => {
                                                                if (this.props.readOnly) return;
                                                                if (!this.validation('crowding')) return;
                                                                this.props.handleCrowding(
                                                                    e.target.value,
                                                                    'resolveUpper',
                                                                    value
                                                                );
                                                            }}
                                                        >
                                                            <FormLabel className={styles.crowdingLabel}>
                                                                {label}
                                                            </FormLabel>
                                                            <div className={styles.crowding}>
                                                                <FormControlLabel
                                                                    className={styles.spacingRadio}
                                                                    value="primarily"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('primarily')}
                                                                />
                                                                <FormControlLabel
                                                                    className={styles.spacingRadio}
                                                                    value="asNeeded"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('asNeeded')}
                                                                />
                                                                <FormControlLabel
                                                                    className={styles.spacingRadio}
                                                                    value="none"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('none')}
                                                                />
                                                            </div>
                                                        </RadioGroup>
                                                        {this.props.spacingAndCrowding.crowding.resolveUpper[value]
                                                            ?.value === 'primarily' ? (
                                                            <div className={styles.specificTeethRow}>
                                                                {value === 'expand' ? (
                                                                    <FormLabel className={styles.specificTeethLabel}>
                                                                        {this.getNotes('specifyWhichDirection')}
                                                                    </FormLabel>
                                                                ) : (
                                                                    <FormLabel className={styles.specificTeethLabel}>
                                                                        {this.getNotes('specificTeeth')}
                                                                    </FormLabel>
                                                                )}
                                                                <TextField
                                                                    className={styles.textField}
                                                                    variant="outlined"
                                                                    placeholder={this.getNotes(
                                                                        'willCheckiDesignOnceReleased'
                                                                    )}
                                                                    inputProps={{
                                                                        style: { padding: 5, color: 'black' },
                                                                    }}
                                                                    defaultValue={
                                                                        this.props.spacingAndCrowding.crowding
                                                                            .resolveUpper[value]?.teeth
                                                                    }
                                                                    onBlur={(e) => {
                                                                        if (!this.validation('crowding')) return;
                                                                        this.props.handleCrowdingTeeth(
                                                                            e.target.value,
                                                                            'resolveUpper',
                                                                            value
                                                                        );
                                                                    }}
                                                                    disabled={this.props.mode === 'view'}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                )}
                                <div
                                    style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                    onClick={() => {
                                        if (this.props.readOnly) return;
                                        handleToggleResolve('resolveLower', !isResolveLower);
                                    }}
                                >
                                    <Radio
                                        checked={isResolveLower}
                                        style={{ color: isResolveLower ? '#3f51b5' : undefined }}
                                    />
                                    <span style={{ fontWeight: 'bold' }}>{this.getNotes('resolveLower')}</span>
                                </div>
                                {isResolveLower && (
                                    <div className={styles.subClass} style={{ marginLeft: 20 }}>
                                        {this.questions.spacingAndCrowding.options[1].options[1].options.map(
                                            ({ value, label }, i) => {
                                                return (
                                                    <div key={i + value}>
                                                        <RadioGroup
                                                            row
                                                            className={styles.row}
                                                            value={
                                                                this.props.spacingAndCrowding.crowding.resolveLower[
                                                                    value
                                                                ]?.value
                                                            }
                                                            onChange={(e) => {
                                                                if (this.props.readOnly) return;
                                                                if (!this.validation('crowding')) return;
                                                                this.props.handleCrowding(
                                                                    e.target.value,
                                                                    'resolveLower',
                                                                    value
                                                                );
                                                            }}
                                                        >
                                                            <FormLabel className={styles.crowdingLabel}>
                                                                {label}
                                                            </FormLabel>
                                                            <div className={styles.crowding}>
                                                                <FormControlLabel
                                                                    className={styles.spacingRadio}
                                                                    value="primarily"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('primarily')}
                                                                />
                                                                <FormControlLabel
                                                                    className={styles.spacingRadio}
                                                                    value="asNeeded"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('asNeeded')}
                                                                />
                                                                <FormControlLabel
                                                                    className={styles.spacingRadio}
                                                                    value="none"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('none')}
                                                                />
                                                            </div>
                                                        </RadioGroup>
                                                        {this.props.spacingAndCrowding.crowding.resolveLower[value]
                                                            ?.value === 'primarily' ? (
                                                            <div className={styles.specificTeethRow}>
                                                                {value === 'expand' ? (
                                                                    <FormLabel className={styles.specificTeethLabel}>
                                                                        {this.getNotes('specifyWhichDirection')}
                                                                    </FormLabel>
                                                                ) : (
                                                                    <FormLabel className={styles.specificTeethLabel}>
                                                                        {this.getNotes('specificTeeth')}
                                                                    </FormLabel>
                                                                )}
                                                                <TextField
                                                                    className={styles.textField}
                                                                    variant="outlined"
                                                                    placeholder={this.getNotes(
                                                                        'willCheckiDesignOnceReleased'
                                                                    )}
                                                                    inputProps={{
                                                                        style: { padding: 5, color: 'black' },
                                                                    }}
                                                                    defaultValue={
                                                                        this.props.spacingAndCrowding.crowding
                                                                            .resolveLower[value]?.teeth
                                                                    }
                                                                    onBlur={(e) => {
                                                                        if (!this.validation('crowding')) return;
                                                                        this.props.handleCrowdingTeeth(
                                                                            e.target.value,
                                                                            'resolveLower',
                                                                            value
                                                                        );
                                                                    }}
                                                                    disabled={this.props.mode === 'view'}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                )}
                            </div>
                        </>
                    );
                };
                return func;
            case 'Q7':
                func = () => (
                    <>
                        <ol start={7}>
                            <li>{this.questions.overjet.label}</li>
                        </ol>
                        <RadioGroup
                            value={this.props.overJet.value}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('overjet')) return;
                                this.props.handleOverJet(e.target.value, 'value');
                            }}
                        >
                            {this.questions.overjet.options.map(({ value, label, options }, i) => {
                                if (options) {
                                    return (
                                        <div key={i + value}>
                                            <FormControlLabel
                                                style={{ width: 'fit-content' }}
                                                value={value}
                                                control={<Radio />}
                                                label={label}
                                            />
                                            <RadioGroup
                                                className={styles.subOptions}
                                                value={this.props.overJet.subValue}
                                                onChange={(e) => {
                                                    if (this.props.readOnly) return;
                                                    if (!this.validation('overjet')) return;
                                                    this.props.handleOverJet(e.target.value, 'subValue');
                                                }}
                                            >
                                                {this.props.overJet.value === 'maintainInitialOverjet' ||
                                                    options.map(({ value, label }, i) => {
                                                        return (
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                value={value}
                                                                control={<Radio />}
                                                                label={label}
                                                                key={i + value}
                                                            />
                                                        );
                                                    })}
                                            </RadioGroup>
                                        </div>
                                    );
                                }

                                return (
                                    <FormControlLabel
                                        style={{ width: 'fit-content' }}
                                        value={value}
                                        control={<Radio />}
                                        label={label}
                                        key={i + value}
                                    />
                                );
                            })}
                        </RadioGroup>
                    </>
                );
                return func;
            case 'Q8':
                const getShowOpenBiteErrorIcon = (field = '') => {
                    if (field === 'extrudeAnteriorTeeth') {
                        return (
                            this.props.openbite.subValue.extrudeAnteriorTeeth.value &&
                            this.props.openbite.subValue.extrudeAnteriorTeeth.value &&
                            !this.props.openbite.subValue.extrudeAnteriorTeeth.upper &&
                            !this.props.openbite.subValue.extrudeAnteriorTeeth.lower
                        );
                    }

                    if (field === 'intrudePosteriorTeeth') {
                        return (
                            this.props.openbite.subValue.intrudePosteriorTeeth.value &&
                            this.props.openbite.subValue.intrudePosteriorTeeth.value &&
                            !this.props.openbite.subValue.intrudePosteriorTeeth.upper &&
                            !this.props.openbite.subValue.intrudePosteriorTeeth.lower
                        );
                    }

                    return false;
                };
                func = () => (
                    <>
                        <ol start={8}>
                            <li>{this.questions.openbite.label}</li>
                        </ol>
                        <RadioGroup
                            value={this.props.openbite.value}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('openbite')) return;
                                this.props.handleOpenBite(e.target.value);
                            }}
                        >
                            {this.questions.openbite.options.map(({ value, label, options }, i) => {
                                if (!options)
                                    return (
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={value}
                                            control={<Radio />}
                                            label={label}
                                            key={i + value}
                                        />
                                    );

                                return (
                                    <div key={i + value}>
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={value}
                                            control={<Radio />}
                                            label={label}
                                        />
                                        <RadioGroup
                                            className={styles.subOptions}
                                            value={this.props.openbite.subValue.value}
                                            onChange={(e) => {
                                                if (this.props.readOnly) return;
                                                if (!this.validation('openbite')) return;
                                                this.props.handleOpenBiteImprove(e.target.value);
                                            }}
                                        >
                                            {this.props.openbite.value === 'maintainInitialOpenbite' ||
                                                options.map(({ value, label, options }, i) => {
                                                    if (value === 'noPreferenceShowResultsInSimulator')
                                                        return (
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                disabled={
                                                                    this.props.openbite.value ===
                                                                    'maintainInitialOpenbite'
                                                                }
                                                                value={value}
                                                                control={<Radio />}
                                                                label={label}
                                                                key={i + value}
                                                            />
                                                        );
                                                    if (!options)
                                                        return (
                                                            <div className={styles.tad}>
                                                                <FormControlLabel
                                                                    style={{ width: 'fit-content' }}
                                                                    key={i + value}
                                                                    value={this.props.openbite.subValue[value].value}
                                                                    control={
                                                                        <Checkbox
                                                                            checked={
                                                                                this.props.openbite.subValue[value]
                                                                                    .value
                                                                            }
                                                                            onChange={() => {
                                                                                if (this.props.readOnly) return;
                                                                                if (!this.validation('openbite'))
                                                                                    return;
                                                                                this.props.handleOpenBiteCheckBox(
                                                                                    value
                                                                                );
                                                                            }}
                                                                        />
                                                                    }
                                                                    label={
                                                                        <Typography style={{ width: 200 }}>
                                                                            {label}
                                                                        </Typography>
                                                                    }
                                                                />
                                                                {this.props.openbite.subValue[value].value && (
                                                                    <>
                                                                        {this.props.openbite.subValue
                                                                            .placeMiniImplantsTAD.value &&
                                                                        !this.props.openbite.subValue
                                                                            .placeMiniImplantsTAD.input ? (
                                                                            <>
                                                                                <RedTextField
                                                                                    fullWidth
                                                                                    disabled={
                                                                                        this.props.mode === 'view'
                                                                                    }
                                                                                    id="Q8TextField"
                                                                                    className={styles.textField}
                                                                                    variant="outlined"
                                                                                    inputProps={{
                                                                                        style: {
                                                                                            padding: 5,
                                                                                            color: 'black',
                                                                                            backgroundColor:
                                                                                                this.props.openbite
                                                                                                    .subValue
                                                                                                    .placeMiniImplantsTAD
                                                                                                    .value &&
                                                                                                !this.props.openbite
                                                                                                    .subValue
                                                                                                    .placeMiniImplantsTAD
                                                                                                    .input &&
                                                                                                this.props
                                                                                                    .prescriptionError &&
                                                                                                this.props
                                                                                                    .prescriptionErrorQuestion ===
                                                                                                    7
                                                                                                    ? '#faff78'
                                                                                                    : null,
                                                                                        },
                                                                                        onClick: () => {
                                                                                            if (
                                                                                                !this.validation(
                                                                                                    'openbite'
                                                                                                )
                                                                                            ) {
                                                                                                document
                                                                                                    .getElementById(
                                                                                                        'Q8TextField'
                                                                                                    )
                                                                                                    .blur();
                                                                                            }
                                                                                        },
                                                                                    }}
                                                                                    placeholder={this.getWarning(
                                                                                        'specifyArea'
                                                                                    )}
                                                                                    defaultValue={
                                                                                        this.props.openbite.subValue[
                                                                                            value
                                                                                        ].input
                                                                                    }
                                                                                    onBlur={(e) => {
                                                                                        if (
                                                                                            !this.validation('openbite')
                                                                                        )
                                                                                            return;
                                                                                        this.props.handleOpenBiteText(
                                                                                            e.target.value
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                <Tooltip
                                                                                    title={this.getNotes(
                                                                                        'requiredInformation'
                                                                                    )}
                                                                                >
                                                                                    <ErrorIcon
                                                                                        style={{ color: 'red' }}
                                                                                    />
                                                                                </Tooltip>
                                                                            </>
                                                                        ) : (
                                                                            <TextField
                                                                                fullWidth
                                                                                disabled={this.props.mode === 'view'}
                                                                                id="Q8TextField"
                                                                                className={styles.textField}
                                                                                variant="outlined"
                                                                                inputProps={{
                                                                                    style: {
                                                                                        padding: 5,
                                                                                        color: 'black',
                                                                                        backgroundColor:
                                                                                            this.props.openbite.subValue
                                                                                                .placeMiniImplantsTAD
                                                                                                .value &&
                                                                                            !this.props.openbite
                                                                                                .subValue
                                                                                                .placeMiniImplantsTAD
                                                                                                .input &&
                                                                                            this.props
                                                                                                .prescriptionError &&
                                                                                            this.props
                                                                                                .prescriptionErrorQuestion ===
                                                                                                7
                                                                                                ? '#faff78'
                                                                                                : null,
                                                                                    },
                                                                                    onClick: () => {
                                                                                        if (
                                                                                            !this.validation('openbite')
                                                                                        ) {
                                                                                            document
                                                                                                .getElementById(
                                                                                                    'Q8TextField'
                                                                                                )
                                                                                                .blur();
                                                                                        }
                                                                                    },
                                                                                }}
                                                                                placeholder={this.getWarning(
                                                                                    'specifyArea'
                                                                                )}
                                                                                defaultValue={
                                                                                    this.props.openbite.subValue[value]
                                                                                        .input
                                                                                }
                                                                                onBlur={(e) => {
                                                                                    if (!this.validation('openbite'))
                                                                                        return;
                                                                                    this.props.handleOpenBiteText(
                                                                                        e.target.value
                                                                                    );
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        );

                                                    return (
                                                        <div key={i + value}>
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                value={this.props.openbite.subValue[value].value}
                                                                disabled={
                                                                    this.props.openbite.value ===
                                                                    'maintainInitialOpenbite'
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={
                                                                            this.props.openbite.subValue[value].value
                                                                        }
                                                                        onChange={() => {
                                                                            if (this.props.readOnly) return;
                                                                            if (!this.validation('openbite')) return;
                                                                            this.props.handleOpenBiteCheckBox(value);
                                                                        }}
                                                                    />
                                                                }
                                                                label={
                                                                    <SubOptCheckBoxLabel
                                                                        label={label}
                                                                        isShowError={getShowOpenBiteErrorIcon(value)}
                                                                    />
                                                                }
                                                            />
                                                            <RadioGroup className={styles.subOptions}>
                                                                <div style={{ display: 'flex' }}>
                                                                    <div
                                                                        id={i + value}
                                                                        style={{ width: 'fit-content' }}
                                                                    >
                                                                        {this.props.openbite.value ===
                                                                            'improveResultingOpenbiteBy' &&
                                                                            this.props.openbite.subValue[value].value &&
                                                                            options.map((sub, i) => {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        style={{
                                                                                            width: 'fit-content',
                                                                                            marginRight: '2px',
                                                                                            display: 'block',
                                                                                            backgroundColor:
                                                                                                value ===
                                                                                                'extrudeAnteriorTeeth'
                                                                                                    ? this.props
                                                                                                          .openbite
                                                                                                          .subValue
                                                                                                          .extrudeAnteriorTeeth
                                                                                                          .value &&
                                                                                                      !this.props
                                                                                                          .openbite
                                                                                                          .subValue
                                                                                                          .extrudeAnteriorTeeth
                                                                                                          .upper &&
                                                                                                      !this.props
                                                                                                          .openbite
                                                                                                          .subValue
                                                                                                          .extrudeAnteriorTeeth
                                                                                                          .lower &&
                                                                                                      this.props
                                                                                                          .prescriptionError &&
                                                                                                      this.props
                                                                                                          .prescriptionErrorQuestion ===
                                                                                                          5
                                                                                                        ? '#faff78'
                                                                                                        : null
                                                                                                    : this.props
                                                                                                            .openbite
                                                                                                            .subValue
                                                                                                            .intrudePosteriorTeeth
                                                                                                            .value &&
                                                                                                        !this.props
                                                                                                            .openbite
                                                                                                            .subValue
                                                                                                            .intrudePosteriorTeeth
                                                                                                            .upper &&
                                                                                                        !this.props
                                                                                                            .openbite
                                                                                                            .subValue
                                                                                                            .intrudePosteriorTeeth
                                                                                                            .lower &&
                                                                                                        this.props
                                                                                                            .prescriptionError &&
                                                                                                        this.props
                                                                                                            .prescriptionErrorQuestion ===
                                                                                                            6
                                                                                                      ? '#faff78'
                                                                                                      : null,
                                                                                        }}
                                                                                        key={i + value}
                                                                                        control={
                                                                                            <Checkbox
                                                                                                checked={
                                                                                                    this.props.openbite
                                                                                                        .subValue[
                                                                                                        value
                                                                                                    ][sub.value]
                                                                                                }
                                                                                                onChange={(e) => {
                                                                                                    if (
                                                                                                        this.props
                                                                                                            .readOnly
                                                                                                    )
                                                                                                        return;
                                                                                                    if (
                                                                                                        !this.validation(
                                                                                                            'openbite'
                                                                                                        )
                                                                                                    )
                                                                                                        return;
                                                                                                    this.props.handleOpenBiteCheckBox(
                                                                                                        sub.value,
                                                                                                        value
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        }
                                                                                        value={
                                                                                            this.props.openbite
                                                                                                .subValue[value][
                                                                                                sub.value
                                                                                            ]
                                                                                        }
                                                                                        label={sub.label}
                                                                                    />
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </div>
                                                            </RadioGroup>
                                                        </div>
                                                    );
                                                })}
                                        </RadioGroup>
                                    </div>
                                );
                            })}
                        </RadioGroup>
                    </>
                );
                return func;
            case 'Q9':
                const getShowErrorIconForDeepBite = (field = '') => {
                    if (field === 'extrudePosteriorTeeth') {
                        return (
                            this.props.deepBite.subValue.extrudePosteriorTeeth.value &&
                            !this.props.deepBite.subValue.extrudePosteriorTeeth.upper &&
                            !this.props.deepBite.subValue.extrudePosteriorTeeth.lower
                        );
                    }

                    if (field === 'intrudeAnteriorTeeth') {
                        return (
                            this.props.deepBite.subValue.intrudeAnteriorTeeth.value &&
                            !this.props.deepBite.subValue.intrudeAnteriorTeeth.upper &&
                            !this.props.deepBite.subValue.intrudeAnteriorTeeth.lower
                        );
                    }

                    return false;
                };
                func = () => (
                    <>
                        <ol start={9}>
                            <li>{this.questions.deepBite.label}</li>
                        </ol>
                        <RadioGroup
                            value={this.props.deepBite.value}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('deepBite')) return;
                                this.props.handleDeepBite(e.target.value);
                            }}
                        >
                            {this.questions.deepBite.options.map(({ value, label, options }, i) => {
                                if (!options)
                                    return (
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={value}
                                            control={<Radio />}
                                            label={label}
                                            key={i + value}
                                        />
                                    );

                                return (
                                    <div key={i + value}>
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={value}
                                            control={<Radio />}
                                            label={label}
                                        />
                                        <RadioGroup
                                            className={styles.subOptions}
                                            value={this.props.deepBite.subValue.value}
                                            onChange={(e) => {
                                                if (this.props.readOnly) return;
                                                if (!this.validation('deepBite')) return;
                                                this.props.handleDeepBiteImprove(e.target.value);
                                            }}
                                        >
                                            {this.props.deepBite.value === 'maintainExistingDeepBite' ||
                                                options.map(({ value, label, options }, i) => {
                                                    if (value === 'noPreference')
                                                        return (
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                disabled={
                                                                    this.props.deepBite.value ===
                                                                    'maintainExistingDeepBite'
                                                                }
                                                                key={i + value}
                                                                value={value}
                                                                control={<Radio />}
                                                                label={label}
                                                            />
                                                        );
                                                    if (!options)
                                                        return (
                                                            <div className={styles.tad}>
                                                                <FormControlLabel
                                                                    style={{ width: 'fit-content' }}
                                                                    key={i + value}
                                                                    value={this.props.deepBite.subValue[value].value}
                                                                    control={
                                                                        <Checkbox
                                                                            checked={
                                                                                this.props.deepBite.subValue[value]
                                                                                    .value
                                                                            }
                                                                            onChange={() => {
                                                                                if (this.props.readOnly) return;
                                                                                if (!this.validation('deepBite'))
                                                                                    return;
                                                                                this.props.handleDeepBiteCheckBox(
                                                                                    value
                                                                                );
                                                                            }}
                                                                        />
                                                                    }
                                                                    label={
                                                                        <Typography style={{ width: 200 }}>
                                                                            {label}
                                                                        </Typography>
                                                                    }
                                                                />
                                                                {this.props.deepBite.subValue[value].value && (
                                                                    <>
                                                                        {this.props.deepBite.subValue
                                                                            .placeMiniImplantsTAD.value &&
                                                                        !this.props.deepBite.subValue
                                                                            .placeMiniImplantsTAD.input ? (
                                                                            <>
                                                                                <RedTextField
                                                                                    fullWidth
                                                                                    placeholder={this.getWarning(
                                                                                        'specifyArea'
                                                                                    )}
                                                                                    id="Q9TextField"
                                                                                    style={{
                                                                                        backgroundColor:
                                                                                            this.props.deepBite.subValue
                                                                                                .placeMiniImplantsTAD
                                                                                                .value &&
                                                                                            !this.props.deepBite
                                                                                                .subValue
                                                                                                .placeMiniImplantsTAD
                                                                                                .input &&
                                                                                            this.props
                                                                                                .prescriptionError &&
                                                                                            this.props
                                                                                                .prescriptionErrorQuestion ===
                                                                                                10
                                                                                                ? '#faff78'
                                                                                                : null,
                                                                                    }}
                                                                                    disabled={
                                                                                        this.props.mode === 'view'
                                                                                    }
                                                                                    className={styles.textField}
                                                                                    variant="outlined"
                                                                                    inputProps={{
                                                                                        style: {
                                                                                            padding: 5,
                                                                                            color: 'black',
                                                                                        },
                                                                                        onClick: () => {
                                                                                            if (
                                                                                                !this.validation(
                                                                                                    'deepBite'
                                                                                                )
                                                                                            ) {
                                                                                                document
                                                                                                    .getElementById(
                                                                                                        'Q9TextField'
                                                                                                    )
                                                                                                    .blur();
                                                                                            }
                                                                                        },
                                                                                    }}
                                                                                    defaultValue={
                                                                                        this.props.deepBite.subValue[
                                                                                            value
                                                                                        ].input
                                                                                    }
                                                                                    onBlur={(e) => {
                                                                                        if (
                                                                                            !this.validation('deepBite')
                                                                                        )
                                                                                            return;
                                                                                        this.props.handleDeepBiteText(
                                                                                            e.target.value
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                <Tooltip
                                                                                    title={this.getNotes(
                                                                                        'requiredInformation'
                                                                                    )}
                                                                                >
                                                                                    <ErrorIcon
                                                                                        style={{ color: 'red' }}
                                                                                    />
                                                                                </Tooltip>
                                                                            </>
                                                                        ) : (
                                                                            <TextField
                                                                                placeholder={this.getWarning(
                                                                                    'specifyArea'
                                                                                )}
                                                                                id="Q9TextField"
                                                                                fullWidth
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        this.props.deepBite.subValue
                                                                                            .placeMiniImplantsTAD
                                                                                            .value &&
                                                                                        !this.props.deepBite.subValue
                                                                                            .placeMiniImplantsTAD
                                                                                            .input &&
                                                                                        this.props.prescriptionError &&
                                                                                        this.props
                                                                                            .prescriptionErrorQuestion ===
                                                                                            10
                                                                                            ? '#faff78'
                                                                                            : null,
                                                                                }}
                                                                                disabled={this.props.mode === 'view'}
                                                                                className={styles.textField}
                                                                                variant="outlined"
                                                                                inputProps={{
                                                                                    style: {
                                                                                        padding: 5,
                                                                                        color: 'black',
                                                                                    },
                                                                                    onClick: () => {
                                                                                        if (
                                                                                            !this.validation('deepBite')
                                                                                        ) {
                                                                                            document
                                                                                                .getElementById(
                                                                                                    'Q9TextField'
                                                                                                )
                                                                                                .blur();
                                                                                        }
                                                                                    },
                                                                                }}
                                                                                defaultValue={
                                                                                    this.props.deepBite.subValue[value]
                                                                                        .input
                                                                                }
                                                                                onBlur={(e) => {
                                                                                    if (!this.validation('deepBite'))
                                                                                        return;
                                                                                    this.props.handleDeepBiteText(
                                                                                        e.target.value
                                                                                    );
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        );

                                                    return (
                                                        <div key={i + value}>
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                value={this.props.deepBite.subValue[value].value}
                                                                disabled={
                                                                    this.props.deepBite.value ===
                                                                    'maintainExistingDeepBite'
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={
                                                                            this.props.deepBite.subValue[value].value
                                                                        }
                                                                        onChange={() => {
                                                                            if (this.props.readOnly) return;
                                                                            if (!this.validation('deepBite')) return;
                                                                            this.props.handleDeepBiteCheckBox(value);
                                                                        }}
                                                                    />
                                                                }
                                                                label={
                                                                    <SubOptCheckBoxLabel
                                                                        label={label}
                                                                        isShowError={getShowErrorIconForDeepBite(value)}
                                                                    />
                                                                }
                                                            />
                                                            <RadioGroup className={styles.subOptions}>
                                                                <div style={{ display: 'flex' }}>
                                                                    <div
                                                                        id={i + value}
                                                                        style={{ width: 'fit-content' }}
                                                                    >
                                                                        {this.props.deepBite.value ===
                                                                            'improveResultingDeepBiteBy' &&
                                                                            this.props.deepBite.subValue[value].value &&
                                                                            options.map((sub, i) => {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        style={{
                                                                                            width: 'fit-content',
                                                                                            marginRight: '2px',
                                                                                            display: 'block',
                                                                                            backgroundColor:
                                                                                                value ===
                                                                                                'intrudeAnteriorTeeth'
                                                                                                    ? this.props
                                                                                                          .deepBite
                                                                                                          .subValue
                                                                                                          .intrudeAnteriorTeeth
                                                                                                          .value &&
                                                                                                      !this.props
                                                                                                          .deepBite
                                                                                                          .subValue
                                                                                                          .intrudeAnteriorTeeth
                                                                                                          .upper &&
                                                                                                      !this.props
                                                                                                          .deepBite
                                                                                                          .subValue
                                                                                                          .intrudeAnteriorTeeth
                                                                                                          .lower &&
                                                                                                      this.props
                                                                                                          .prescriptionError &&
                                                                                                      this.props
                                                                                                          .prescriptionErrorQuestion ===
                                                                                                          9
                                                                                                        ? '#faff78'
                                                                                                        : null
                                                                                                    : this.props
                                                                                                            .deepBite
                                                                                                            .subValue
                                                                                                            .extrudePosteriorTeeth
                                                                                                            .value &&
                                                                                                        !this.props
                                                                                                            .deepBite
                                                                                                            .subValue
                                                                                                            .extrudePosteriorTeeth
                                                                                                            .upper &&
                                                                                                        !this.props
                                                                                                            .deepBite
                                                                                                            .subValue
                                                                                                            .extrudePosteriorTeeth
                                                                                                            .lower &&
                                                                                                        this.props
                                                                                                            .prescriptionError &&
                                                                                                        this.props
                                                                                                            .prescriptionErrorQuestion ===
                                                                                                            8
                                                                                                      ? '#faff78'
                                                                                                      : null,
                                                                                        }}
                                                                                        key={i + value}
                                                                                        value={
                                                                                            this.props.deepBite
                                                                                                .subValue[value][
                                                                                                sub.value
                                                                                            ]
                                                                                        }
                                                                                        control={
                                                                                            <Checkbox
                                                                                                checked={
                                                                                                    this.props.deepBite
                                                                                                        .subValue[
                                                                                                        value
                                                                                                    ][sub.value]
                                                                                                }
                                                                                                onChange={(e) => {
                                                                                                    if (
                                                                                                        !this.validation(
                                                                                                            'deepBite'
                                                                                                        )
                                                                                                    )
                                                                                                        return;
                                                                                                    this.props.handleDeepBiteCheckBox(
                                                                                                        sub.value,
                                                                                                        value
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        }
                                                                                        label={sub.label}
                                                                                    />
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </div>
                                                            </RadioGroup>
                                                        </div>
                                                    );
                                                })}
                                        </RadioGroup>
                                    </div>
                                );
                            })}
                        </RadioGroup>
                    </>
                );
                return func;
            case 'Q10':
                const getMidlineErrorIcon = (value) => {
                    if (value === 'upper') {
                        return this.props.midline.subValue.upper.checked && !this.props.midline.subValue.upper.value;
                    }

                    if (value === 'lower') {
                        return this.props.midline.subValue.lower.checked && !this.props.midline.subValue.lower.value;
                    }
                    return false;
                };
                func = () => (
                    <>
                        <ol start={10}>
                            <li>{this.questions.midline.label}</li>
                        </ol>
                        <RadioGroup
                            value={this.props.midline.value}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('midline')) return;
                                this.props.handleMidline(e.target.value);
                            }}
                        >
                            {this.questions.midline.options.map(({ value, label, options }, i) => {
                                if (!options)
                                    return (
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={value}
                                            control={<Radio />}
                                            label={label}
                                            key={i + value}
                                        />
                                    );

                                return (
                                    <div key={i + value}>
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={value}
                                            control={<Radio />}
                                            label={label}
                                        />
                                        <RadioGroup
                                            className={styles.subOptions}
                                            value={this.props.midline.subValue.value}
                                            onChange={(e) => {
                                                if (this.props.readOnly) return;
                                                if (!this.validation('midline')) return;
                                                this.props.handleMidlineImprove(e.target.value);
                                            }}
                                        >
                                            {this.props.midline.value === 'maintainInitialMidline' ||
                                                options.map(({ value, label, options }, i) => {
                                                    if (value === 'noPreference')
                                                        return (
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                key={i + value}
                                                                value={value}
                                                                control={<Radio />}
                                                                label={label}
                                                            />
                                                        );

                                                    return (
                                                        <div key={i + value}>
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                value={this.props.midline.subValue[value].checked}
                                                                control={
                                                                    <Checkbox
                                                                        checked={
                                                                            this.props.midline.subValue[value].checked
                                                                        }
                                                                        onChange={() => {
                                                                            if (!this.validation('midline')) return;
                                                                            this.props.handleMidlineImprove(
                                                                                false,
                                                                                value
                                                                            );
                                                                        }}
                                                                    />
                                                                }
                                                                label={
                                                                    <SubOptCheckBoxLabel
                                                                        label={label}
                                                                        isShowError={getMidlineErrorIcon(value)}
                                                                    />
                                                                }
                                                                disabled={
                                                                    this.props.midline.value ===
                                                                    'maintainInitialMidline'
                                                                }
                                                            />
                                                            <RadioGroup
                                                                className={styles.subOptions}
                                                                value={this.props.midline.subValue[value].value}
                                                                onChange={(e) => {
                                                                    if (this.props.readOnly) return;
                                                                    if (!this.validation('midline')) return;
                                                                    this.props.handleMidlinePosition(
                                                                        e.target.value,
                                                                        value
                                                                    );
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex' }}>
                                                                    <div
                                                                        id={i + value}
                                                                        style={{ width: 'fit-content' }}
                                                                    >
                                                                        {this.props.midline.value ===
                                                                            'maintainInitialMidline' ||
                                                                            !this.props.midline.subValue[value]
                                                                                .checked ||
                                                                            options.map((sub, i) => {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        style={{
                                                                                            width: 'fit-content',
                                                                                            marginRight: '2px',
                                                                                            display: 'block',
                                                                                            backgroundColor:
                                                                                                value === 'upper'
                                                                                                    ? this.props.midline
                                                                                                          .subValue
                                                                                                          .upper
                                                                                                          .checked &&
                                                                                                      !this.props
                                                                                                          .midline
                                                                                                          .subValue
                                                                                                          .upper
                                                                                                          .value &&
                                                                                                      this.props
                                                                                                          .prescriptionError &&
                                                                                                      this.props
                                                                                                          .prescriptionErrorQuestion ===
                                                                                                          12
                                                                                                        ? '#faff78'
                                                                                                        : null
                                                                                                    : this.props.midline
                                                                                                            .subValue
                                                                                                            .lower
                                                                                                            .checked &&
                                                                                                        !this.props
                                                                                                            .midline
                                                                                                            .subValue
                                                                                                            .lower
                                                                                                            .value &&
                                                                                                        this.props
                                                                                                            .prescriptionError &&
                                                                                                        this.props
                                                                                                            .prescriptionErrorQuestion ===
                                                                                                            11
                                                                                                      ? '#faff78'
                                                                                                      : null,
                                                                                        }}
                                                                                        key={i + sub.value}
                                                                                        value={sub.value}
                                                                                        control={<Radio />}
                                                                                        label={sub.label}
                                                                                    />
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </div>
                                                            </RadioGroup>
                                                        </div>
                                                    );
                                                })}
                                        </RadioGroup>
                                    </div>
                                );
                            })}
                        </RadioGroup>
                    </>
                );
                return func;
            case 'Q11':
                func = () => (
                    <>
                        <ol start={11}>
                            <li>{this.questions.posteriorCrossbite.label}</li>
                        </ol>
                        <RadioGroup
                            value={this.props.posteriorCrossbite.value}
                            onChange={(e) => {
                                if (this.props.readOnly) return;
                                if (!this.validation('posteriorCrossbite')) return;
                                this.props.handlePosteriorCrossbite(e.target.value);
                            }}
                            ref={this.myRef}
                        >
                            {this.questions.posteriorCrossbite.options.map(({ value, label, options }, i) => {
                                if (!options)
                                    return (
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={value}
                                            control={<Radio />}
                                            label={label}
                                            key={i + value}
                                        />
                                    );

                                return (
                                    <div key={i + value}>
                                        <FormControlLabel
                                            style={{ width: 'fit-content' }}
                                            value={value}
                                            control={<Radio />}
                                            label={label}
                                        />
                                        <RadioGroup
                                            className={styles.subOptions}
                                            value={this.props.posteriorCrossbite.subValue.value}
                                            onChange={(e) => {
                                                if (this.props.readOnly) return;
                                                if (!this.validation('posteriorCrossbite')) return;
                                                this.props.handlePosteriorCrossbiteCorrect(e.target.value);
                                            }}
                                        >
                                            {this.props.posteriorCrossbite.value === 'maintainInitialCrossbite' ||
                                                options.map(({ value, label, options }, i) => {
                                                    if (value === 'otherMethods')
                                                        return (
                                                            <div className={styles.tad}>
                                                                <FormControlLabel
                                                                    style={{ width: 'fit-content' }}
                                                                    key={i + value}
                                                                    value={value}
                                                                    control={<Radio />}
                                                                    label={label}
                                                                />
                                                                {this.props.posteriorCrossbite.subValue.value ===
                                                                    'otherMethods' && (
                                                                    <>
                                                                        {this.props.posteriorCrossbite.subValue
                                                                            .value === 'otherMethods' &&
                                                                        !this.props.posteriorCrossbite.subValue.subValue
                                                                            .otherMethod ? (
                                                                            <>
                                                                                <RedTextField
                                                                                    id="Q11TextField"
                                                                                    placeholder={this.getWarning(
                                                                                        'otherMethods'
                                                                                    )}
                                                                                    style={{
                                                                                        width: 400,
                                                                                        backgroundColor:
                                                                                            this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.value ===
                                                                                                'otherMethods' &&
                                                                                            !this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.subValue
                                                                                                .otherMethod &&
                                                                                            this.props
                                                                                                .prescriptionError &&
                                                                                            this.props
                                                                                                .prescriptionErrorQuestion ===
                                                                                                17
                                                                                                ? '#faff78'
                                                                                                : null,
                                                                                    }}
                                                                                    disabled={
                                                                                        this.props.mode === 'view'
                                                                                    }
                                                                                    className={styles.textField}
                                                                                    variant="outlined"
                                                                                    inputProps={{
                                                                                        style: {
                                                                                            padding: 5,
                                                                                            color: 'black',
                                                                                        },
                                                                                    }}
                                                                                    defaultValue={
                                                                                        this.props.posteriorCrossbite
                                                                                            .subValue.subValue
                                                                                            .otherMethod
                                                                                    }
                                                                                    onClick={(e) => {
                                                                                        if (
                                                                                            !this.validation(
                                                                                                'posteriorCrossbite'
                                                                                            )
                                                                                        ) {
                                                                                            document
                                                                                                .getElementById(
                                                                                                    'Q11TextField'
                                                                                                )
                                                                                                .blur();
                                                                                        }
                                                                                    }}
                                                                                    onBlur={(e) => {
                                                                                        this.props.handlePosteriorCrossbiteOther(
                                                                                            e.target.value
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                <Tooltip
                                                                                    title={this.getNotes(
                                                                                        'requiredInformation'
                                                                                    )}
                                                                                >
                                                                                    <ErrorIcon
                                                                                        style={{ color: 'red' }}
                                                                                    />
                                                                                </Tooltip>
                                                                            </>
                                                                        ) : (
                                                                            <TextField
                                                                                id="Q11TextField"
                                                                                placeholder={this.getWarning(
                                                                                    'otherMethods'
                                                                                )}
                                                                                style={{
                                                                                    width: 400,
                                                                                    backgroundColor:
                                                                                        this.props.posteriorCrossbite
                                                                                            .subValue.value ===
                                                                                            'otherMethods' &&
                                                                                        !this.props.posteriorCrossbite
                                                                                            .subValue.subValue
                                                                                            .otherMethod &&
                                                                                        this.props.prescriptionError &&
                                                                                        this.props
                                                                                            .prescriptionErrorQuestion ===
                                                                                            17
                                                                                            ? '#faff78'
                                                                                            : null,
                                                                                }}
                                                                                disabled={this.props.mode === 'view'}
                                                                                className={styles.textField}
                                                                                variant="outlined"
                                                                                inputProps={{
                                                                                    style: {
                                                                                        padding: 5,
                                                                                        color: 'black',
                                                                                    },
                                                                                }}
                                                                                defaultValue={
                                                                                    this.props.posteriorCrossbite
                                                                                        .subValue.subValue.otherMethod
                                                                                }
                                                                                onClick={(e) => {
                                                                                    if (
                                                                                        !this.validation(
                                                                                            'posteriorCrossbite'
                                                                                        )
                                                                                    ) {
                                                                                        document
                                                                                            .getElementById(
                                                                                                'Q11TextField'
                                                                                            )
                                                                                            .blur();
                                                                                    }
                                                                                }}
                                                                                onBlur={(e) => {
                                                                                    this.props.handlePosteriorCrossbiteOther(
                                                                                        e.target.value
                                                                                    );
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        );
                                                    if (!options)
                                                        return (
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                key={i + value}
                                                                value={value}
                                                                control={<Radio />}
                                                                label={label}
                                                            />
                                                        );

                                                    return (
                                                        <>
                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                value={value}
                                                                control={<Radio />}
                                                                label={label}
                                                            />
                                                            <RadioGroup
                                                                className={styles.subOptions}
                                                                value={
                                                                    this.props.posteriorCrossbite.subValue.subValue
                                                                        .value
                                                                }
                                                                onChange={(e) => {
                                                                    if (this.props.readOnly) return;
                                                                    if (!this.validation('posteriorCrossbite')) return;
                                                                    this.props.handlePosteriorCrossbiteCorrect(
                                                                        e.target.value,
                                                                        true
                                                                    );
                                                                }}
                                                            >
                                                                {this.props.posteriorCrossbite.subValue.value !==
                                                                    value ||
                                                                    options.map((subOption, i) => {
                                                                        return (
                                                                            <div key={i + subOption.value}>
                                                                                <FormControlLabel
                                                                                    style={{ width: 'fit-content' }}
                                                                                    value={subOption.value}
                                                                                    control={<Radio />}
                                                                                    label={
                                                                                        subOption.label.includes(
                                                                                            '2nd'
                                                                                        ) ? (
                                                                                            <>
                                                                                                {
                                                                                                    subOption.label.split(
                                                                                                        '2nd'
                                                                                                    )[0]
                                                                                                }
                                                                                                2
                                                                                                <sup
                                                                                                    style={{
                                                                                                        fontFamily:
                                                                                                            'Arial, Helvetica, sans-serif',
                                                                                                    }}
                                                                                                >
                                                                                                    nd
                                                                                                </sup>
                                                                                                {
                                                                                                    subOption.label.split(
                                                                                                        '2nd'
                                                                                                    )[1]
                                                                                                }
                                                                                            </>
                                                                                        ) : (
                                                                                            subOption.label
                                                                                        )
                                                                                    }
                                                                                    disabled={
                                                                                        this.props.posteriorCrossbite
                                                                                            .subValue.value !== value
                                                                                    }
                                                                                />
                                                                                <RadioGroup
                                                                                    className={styles.subOptions}
                                                                                >
                                                                                    <div style={{ display: 'flex' }}>
                                                                                        <div
                                                                                            id={i + value}
                                                                                            style={{
                                                                                                width: 'fit-content',
                                                                                            }}
                                                                                        >
                                                                                            {this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.subValue
                                                                                                .value !==
                                                                                                subOption.value ||
                                                                                                subOption.options.map(
                                                                                                    (sub, i) => {
                                                                                                        return (
                                                                                                            <FormControlLabel
                                                                                                                style={{
                                                                                                                    width: 'fit-content',
                                                                                                                    marginRight:
                                                                                                                        '2px',
                                                                                                                    display:
                                                                                                                        'block',
                                                                                                                    backgroundColor:
                                                                                                                        subOption.value ===
                                                                                                                        'cutoutToBondButtonDirectlyOnTeeth'
                                                                                                                            ? this
                                                                                                                                  .props
                                                                                                                                  .posteriorCrossbite
                                                                                                                                  .subValue
                                                                                                                                  .subValue
                                                                                                                                  .value ===
                                                                                                                                  'cutoutToBondButtonDirectlyOnTeeth' &&
                                                                                                                              !this
                                                                                                                                  .props
                                                                                                                                  .posteriorCrossbite
                                                                                                                                  .subValue
                                                                                                                                  .subValue
                                                                                                                                  .cutoutToBondButtonDirectlyOnTeeth
                                                                                                                                  .mandibularTeeth &&
                                                                                                                              !this
                                                                                                                                  .props
                                                                                                                                  .posteriorCrossbite
                                                                                                                                  .subValue
                                                                                                                                  .subValue
                                                                                                                                  .cutoutToBondButtonDirectlyOnTeeth
                                                                                                                                  .maxillaryTeeth &&
                                                                                                                              this
                                                                                                                                  .props
                                                                                                                                  .prescriptionError &&
                                                                                                                              this
                                                                                                                                  .props
                                                                                                                                  .prescriptionErrorQuestion ===
                                                                                                                                  16
                                                                                                                                ? '#faff78'
                                                                                                                                : null
                                                                                                                            : this
                                                                                                                                    .props
                                                                                                                                    .posteriorCrossbite
                                                                                                                                    .subValue
                                                                                                                                    .subValue
                                                                                                                                    .value ===
                                                                                                                                    'buttonPressedDirectlyOnAligner' &&
                                                                                                                                !this
                                                                                                                                    .props
                                                                                                                                    .posteriorCrossbite
                                                                                                                                    .subValue
                                                                                                                                    .subValue
                                                                                                                                    .buttonPressedDirectlyOnAligner
                                                                                                                                    .mandibularTeeth &&
                                                                                                                                !this
                                                                                                                                    .props
                                                                                                                                    .posteriorCrossbite
                                                                                                                                    .subValue
                                                                                                                                    .subValue
                                                                                                                                    .buttonPressedDirectlyOnAligner
                                                                                                                                    .maxillaryTeeth &&
                                                                                                                                this
                                                                                                                                    .props
                                                                                                                                    .prescriptionError &&
                                                                                                                                this
                                                                                                                                    .props
                                                                                                                                    .prescriptionErrorQuestion ===
                                                                                                                                    13
                                                                                                                              ? '#faff78'
                                                                                                                              : null,
                                                                                                                }}
                                                                                                                key={
                                                                                                                    i +
                                                                                                                    sub.value
                                                                                                                }
                                                                                                                value={
                                                                                                                    this
                                                                                                                        .props
                                                                                                                        .posteriorCrossbite
                                                                                                                        .subValue
                                                                                                                        .subValue[
                                                                                                                        subOption
                                                                                                                            .value
                                                                                                                    ][
                                                                                                                        sub
                                                                                                                            .value
                                                                                                                    ]
                                                                                                                }
                                                                                                                control={
                                                                                                                    <Checkbox
                                                                                                                        checked={
                                                                                                                            this
                                                                                                                                .props
                                                                                                                                .posteriorCrossbite
                                                                                                                                .subValue
                                                                                                                                .subValue[
                                                                                                                                subOption
                                                                                                                                    .value
                                                                                                                            ][
                                                                                                                                sub
                                                                                                                                    .value
                                                                                                                            ]
                                                                                                                        }
                                                                                                                        onChange={() => {
                                                                                                                            if (
                                                                                                                                this
                                                                                                                                    .props
                                                                                                                                    .readOnly
                                                                                                                            )
                                                                                                                                return;
                                                                                                                            if (
                                                                                                                                !this.validation(
                                                                                                                                    'posteriorCrossbite'
                                                                                                                                )
                                                                                                                            )
                                                                                                                                return;
                                                                                                                            this.props.handlePosteriorCrossbiteTeeth(
                                                                                                                                subOption.value,
                                                                                                                                sub.value
                                                                                                                            );
                                                                                                                        }}
                                                                                                                    />
                                                                                                                }
                                                                                                                label={
                                                                                                                    sub.label
                                                                                                                }
                                                                                                            />
                                                                                                        );
                                                                                                    }
                                                                                                )}
                                                                                        </div>
                                                                                        {i + value ===
                                                                                            '0interarchElastics' &&
                                                                                            this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.subValue
                                                                                                .value ===
                                                                                                'cutoutToBondButtonDirectlyOnTeeth' &&
                                                                                            this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.value ===
                                                                                                'interarchElastics' &&
                                                                                            !this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.subValue
                                                                                                .cutoutToBondButtonDirectlyOnTeeth
                                                                                                .mandibularTeeth &&
                                                                                            !this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.subValue
                                                                                                .cutoutToBondButtonDirectlyOnTeeth
                                                                                                .maxillaryTeeth && (
                                                                                                <Tooltip
                                                                                                    title={this.getNotes(
                                                                                                        'requiredInformation'
                                                                                                    )}
                                                                                                >
                                                                                                    <ErrorIcon
                                                                                                        style={{
                                                                                                            color: 'red',
                                                                                                        }}
                                                                                                    />
                                                                                                </Tooltip>
                                                                                            )}
                                                                                        {i + value ===
                                                                                            '1interarchElastics' &&
                                                                                            this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.subValue
                                                                                                .value ===
                                                                                                'buttonPressedDirectlyOnAligner' &&
                                                                                            this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.value ===
                                                                                                'interarchElastics' &&
                                                                                            !this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.subValue
                                                                                                .buttonPressedDirectlyOnAligner
                                                                                                .mandibularTeeth &&
                                                                                            !this.props
                                                                                                .posteriorCrossbite
                                                                                                .subValue.subValue
                                                                                                .buttonPressedDirectlyOnAligner
                                                                                                .maxillaryTeeth && (
                                                                                                <Tooltip
                                                                                                    title={this.getNotes(
                                                                                                        'requiredInformation'
                                                                                                    )}
                                                                                                >
                                                                                                    <ErrorIcon
                                                                                                        style={{
                                                                                                            color: 'red',
                                                                                                        }}
                                                                                                    />
                                                                                                </Tooltip>
                                                                                            )}
                                                                                    </div>
                                                                                </RadioGroup>
                                                                            </div>
                                                                        );
                                                                    })}
                                                            </RadioGroup>
                                                        </>
                                                    );
                                                })}
                                        </RadioGroup>
                                    </div>
                                );
                            })}
                        </RadioGroup>
                    </>
                );
                return func;
            case 'Q12':
                func = () => (
                    <>
                        <ol start={12}>
                            <li>{this.questions.auxiliaries.label}</li>
                        </ol>
                        <ol className={styles.olNoStyle}>
                            <li>
                                {this.questions.auxiliaries.options[0].label}
                                <ul className={styles.romanli}>
                                    {this.questions.auxiliaries.options[0].options.map(
                                        ({ value, label, options }, i) => {
                                            if (!options)
                                                return (
                                                    <div
                                                        key={i + value}
                                                        style={{
                                                            backgroundColor:
                                                                this.props.prescriptionError ===
                                                                    this.getWarning('elastic') &&
                                                                this.state.errorFrom === 'auxiliaries'
                                                                    ? '#faff78'
                                                                    : null,
                                                        }}
                                                    >
                                                        <li>
                                                            <RadioGroup
                                                                row
                                                                name={value}
                                                                className={styles.row}
                                                                value={this.props.auxiliaries[value]}
                                                                onChange={(e) => {
                                                                    if (this.props.readOnly) return;
                                                                    if (!this.validation('auxiliaries')) return;
                                                                    if (
                                                                        e.target.value === 'Yes' &&
                                                                        (this.props.auxiliaries.classIIElastics ===
                                                                            'Yes' ||
                                                                            this.props.auxiliaries.classIIIElastics ===
                                                                                'Yes')
                                                                    ) {
                                                                        this.props.handlePrescriptionError(
                                                                            this.getWarning('elastic_v2')
                                                                        );
                                                                        this.changeState('errorFrom', 'auxiliaries');
                                                                        this.handleDialog();
                                                                        return;
                                                                    }
                                                                    this.props.handleAuxiliaries(value, e.target.value);
                                                                }}
                                                            >
                                                                <FormLabel className={styles.listItemLabel}>
                                                                    {label}
                                                                </FormLabel>
                                                                <FormControlLabel
                                                                    style={{ width: 'fit-content' }}
                                                                    value="Yes"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('yes')}
                                                                />
                                                                <FormControlLabel
                                                                    style={{ width: 'fit-content' }}
                                                                    value="No"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('no')}
                                                                />
                                                            </RadioGroup>
                                                        </li>
                                                    </div>
                                                );

                                            if (value === 'otherElastics')
                                                return (
                                                    <>
                                                        <li style={{ marginTop: 10 }}>
                                                            <FormLabel className={styles.listItemLabel}>
                                                                {label}
                                                            </FormLabel>
                                                        </li>
                                                        <RadioGroup
                                                            name={value}
                                                            value={this.props.auxiliaries[value].value}
                                                            onChange={(e) => {
                                                                if (this.props.readOnly) return;
                                                                if (!this.validation('auxiliaries')) return;
                                                                this.props.handleAuxiliariesOther(e.target.value);
                                                            }}
                                                        >
                                                            <div>
                                                                <FormControlLabel
                                                                    style={{ width: 'fit-content' }}
                                                                    value="Yes"
                                                                    control={<Radio />}
                                                                    label={this.getNotes('yes')}
                                                                />
                                                                {this.props.auxiliaries[value].value === 'No' || (
                                                                    <>
                                                                        {this.props.auxiliaries.otherElastics.value ===
                                                                            'Yes' &&
                                                                        !this.props.auxiliaries.otherElastics
                                                                            .comment ? (
                                                                            <>
                                                                                <RedTextField
                                                                                    id="Q12TextField"
                                                                                    className={styles.textField}
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    defaultValue={
                                                                                        this.props.auxiliaries
                                                                                            .otherElastics.comment
                                                                                    }
                                                                                    placeholder={this.getNotes(
                                                                                        'otherElasticsHintText'
                                                                                    )}
                                                                                    style={{
                                                                                        width: 600,
                                                                                        backgroundColor:
                                                                                            this.props.auxiliaries
                                                                                                .otherElastics.value ===
                                                                                                'Yes' &&
                                                                                            !this.props.auxiliaries
                                                                                                .otherElastics
                                                                                                .comment &&
                                                                                            this.props
                                                                                                .prescriptionError &&
                                                                                            this.props
                                                                                                .prescriptionErrorQuestion ===
                                                                                                14
                                                                                                ? '#faff78'
                                                                                                : null,
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        if (
                                                                                            !this.validation(
                                                                                                'auxiliaries'
                                                                                            )
                                                                                        ) {
                                                                                            document
                                                                                                .getElementById(
                                                                                                    'Q12TextField'
                                                                                                )
                                                                                                .blur();
                                                                                        }
                                                                                    }}
                                                                                    onBlur={(e) => {
                                                                                        this.props.handleAuxiliariesOther(
                                                                                            e.target.value,
                                                                                            value
                                                                                        );
                                                                                    }}
                                                                                    inputProps={{
                                                                                        style: { color: 'black' },
                                                                                    }}
                                                                                    disabled={
                                                                                        this.props.mode === 'view'
                                                                                    }
                                                                                />
                                                                                <Tooltip
                                                                                    title={this.getNotes(
                                                                                        'requiredInformation'
                                                                                    )}
                                                                                >
                                                                                    <ErrorIcon
                                                                                        style={{ color: 'red' }}
                                                                                    />
                                                                                </Tooltip>
                                                                            </>
                                                                        ) : (
                                                                            <TextField
                                                                                id="Q12TextField"
                                                                                className={styles.textField}
                                                                                variant="outlined"
                                                                                size="small"
                                                                                defaultValue={
                                                                                    this.props.auxiliaries.otherElastics
                                                                                        .comment
                                                                                }
                                                                                placeholder={this.getNotes(
                                                                                    'otherElasticsHintText'
                                                                                )}
                                                                                style={{
                                                                                    width: 600,
                                                                                    backgroundColor:
                                                                                        this.props.auxiliaries
                                                                                            .otherElastics.value ===
                                                                                            'Yes' &&
                                                                                        !this.props.auxiliaries
                                                                                            .otherElastics.comment &&
                                                                                        this.props.prescriptionError &&
                                                                                        this.props
                                                                                            .prescriptionErrorQuestion ===
                                                                                            14
                                                                                            ? '#faff78'
                                                                                            : null,
                                                                                }}
                                                                                onClick={() => {
                                                                                    if (
                                                                                        !this.validation('auxiliaries')
                                                                                    ) {
                                                                                        document
                                                                                            .getElementById(
                                                                                                'Q12TextField'
                                                                                            )
                                                                                            .blur();
                                                                                    }
                                                                                }}
                                                                                onBlur={(e) => {
                                                                                    this.props.handleAuxiliariesOther(
                                                                                        e.target.value,
                                                                                        value
                                                                                    );
                                                                                }}
                                                                                inputProps={{
                                                                                    style: { color: 'black' },
                                                                                }}
                                                                                disabled={this.props.mode === 'view'}
                                                                            />
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>

                                                            <FormControlLabel
                                                                style={{ width: 'fit-content' }}
                                                                value="No"
                                                                control={<Radio />}
                                                                label={this.getNotes('no')}
                                                            />
                                                        </RadioGroup>
                                                    </>
                                                );

                                            return (
                                                <div key={i + value} style={{ marginTop: 10 }}>
                                                    {this.props.auxiliaries.classIIElastics === 'Yes' ||
                                                    this.props.auxiliaries.classIIIElastics === 'Yes' ? (
                                                        <>
                                                            <FormLabel className={styles.listItemLabel}>
                                                                {label}
                                                            </FormLabel>
                                                            <RadioGroup
                                                                name={value}
                                                                style={{ marginTop: 10, marginLeft: 20 }}
                                                            >
                                                                {options.map((option, i) => {
                                                                    return (
                                                                        <>
                                                                            <Typography className={styles.underline}>
                                                                                {option.label}
                                                                            </Typography>
                                                                            <ol
                                                                                className={
                                                                                    styles.elasticEngagementPreferenceChoice
                                                                                }
                                                                            >
                                                                                <RadioGroup
                                                                                    name={option.value}
                                                                                    value={
                                                                                        this.props.auxiliaries.subValue[
                                                                                            option.value
                                                                                        ].value
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        if (this.props.readOnly) return;
                                                                                        if (
                                                                                            !this.validation(
                                                                                                'auxiliaries'
                                                                                            )
                                                                                        )
                                                                                            return;
                                                                                        this.props.handleAuxiliaries(
                                                                                            value,
                                                                                            e.target.value,
                                                                                            option.value
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    {option.options.map(
                                                                                        ({ value, label }, i) => {
                                                                                            return (
                                                                                                <FormControlLabel
                                                                                                    key={i}
                                                                                                    style={{
                                                                                                        width: 'fit-content',
                                                                                                    }}
                                                                                                    value={value}
                                                                                                    control={<Radio />}
                                                                                                    label={label}
                                                                                                />
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                                </RadioGroup>
                                                                            </ol>
                                                                        </>
                                                                    );
                                                                })}
                                                            </RadioGroup>
                                                        </>
                                                    ) : null}
                                                </div>
                                            );
                                        }
                                    )}
                                </ul>
                            </li>
                        </ol>
                    </>
                );
                return func;
            case 'trioDimForce':
                func = () => (
                    <>
                        <ol start={13}>
                            <li>
                                {this.questions.trioDimForce.label}
                                <button
                                    className={styles.trio_dim_learn_more}
                                    onClick={() => this.setState({ trioDimModalOpen: true })}
                                >
                                    {this.getNotes('learnMore')}
                                </button>
                            </li>
                        </ol>
                        <div style={{ marginTop: 10 }}>
                            <RadioGroup
                                name="trioDimForce"
                                value={this.props.trioDimForce}
                                onChange={(e) => {
                                    if (this.props.readOnly) return;
                                    this.props.handleTrioDimForce(e.target.value);
                                }}
                            >
                                {this.questions.trioDimForce.options.map((opt) => {
                                    return <FormControlLabel value={opt.value} control={<Radio />} label={opt.label} />;
                                })}
                            </RadioGroup>
                        </div>
                    </>
                );
                return func;
            case 'restorativeOptions':
                func = () => (
                    <ol start={14}>
                        <li>
                            <RestorativeOptions
                                question={this.questions.restorativeOptions}
                                readOnly={this.props.readOnly}
                                teeth={this.teeth}
                                handleToothClick={this.handleClick}
                                validation={this.validation}
                            />
                        </li>
                    </ol>
                );
                return func;
            case 'preImplantAligment':
                func = () => (
                    <ol start={15}>
                        <li>
                            <PreImplantAligment
                                teeth={this.teeth}
                                readOnly={this.props.readOnly}
                                handleToothClick={this.handleClick}
                                question={this.questions.preImplantAligment}
                            />
                        </li>
                    </ol>
                );
                return func;
            case 'addOnSmileDesign':
                func = () => (
                    <ol start={16}>
                        <li>
                            <AddOnSmileDesign
                                question={this.questions.addOnSmileDesign}
                                readOnly={this.props.readOnly}
                            />
                        </li>
                    </ol>
                );
                return func;
            default:
                return func;
        }
    };

    getExpandingGridValueDisplay = (questionId) => {
        let found = undefined;
        switch (questionId) {
            case 'Q1':
                return (
                    this.questions.archToTreat.options.find((opt) => opt.value === this.props.archToTreat)?.label ?? ''
                );
            case 'Q3':
                found = this.questions.attachments.options.find((opt) => opt.value === this.props.attachments.value);
                let delayFound = this.props.attachments?.delay;
                let foundText = found ? found?.expandingGridLabel : '';
                let delayText = '';
                if (delayFound && delayFound?.value === 'delayToStage') {
                    if (delayFound.stage) {
                        delayText = `${this.getNotes('delayToStage')}: ${delayFound.stage}`;
                    } else {
                        delayText = this.getNotes('delayStage_v2');
                    }
                }
                return (
                    <div>
                        <div>{foundText}</div>
                        <div>{delayText}</div>
                    </div>
                );
            case 'Q4':
                found = this.questions.alignersMarginPlacement.options.find(
                    (opt) => opt.value === this.props.alignersMarginPlacement
                );
                if (found) {
                    return found.label;
                }
                break;
            case 'Q5':
                let leftValue = this.questions.anteriorPosteriorRelationship.options.find(
                    (opt) => opt.value === this.props.anteriorPosteriorRelationship.l
                );
                let rightValue = this.questions.anteriorPosteriorRelationship.options.find(
                    (opt) => opt.value === this.props.anteriorPosteriorRelationship.r
                );
                return (
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto 1fr',
                            gap: '4px 18px',
                            alignItems: 'center',
                        }}
                    >
                        <span>
                            <strong>{this.get('@global.const.Left')}:</strong>
                        </span>
                        <span>{leftValue?.label ?? ''}</span>
                        <span>
                            <strong>{this.get('@global.const.Right')}:</strong>
                        </span>
                        <span>{rightValue?.label ?? ''}</span>
                    </div>
                );
            case 'Q6':
                let spaceValue = this.questions.spacingAndCrowding.options[0].options.find(
                    (opt) => opt.value === this.props.spacingAndCrowding.spacing.value
                );
                const initialDefalutValue = initialState.spacingAndCrowding1;
                const isCrowdingValueChanged =
                    _.isEqual(this.props.spacingAndCrowding.crowding, initialDefalutValue.crowding) === false;
                const text = !isCrowdingValueChanged
                    ? this.getNotes('resolveAsNeeded')
                    : this.getNotes('resloveDetail');

                const crowdingValues = [
                    ...Object.values(this.props.spacingAndCrowding.crowding.resolveUpper),
                    ...Object.values(this.props.spacingAndCrowding.crowding.resolveLower),
                ];
                console.debug(crowdingValues);
                const isCrowdingAllFilled = crowdingValues.every(({ value }) => value != null);

                return (
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto 1fr',
                            gap: '4px 18px',
                            alignItems: 'center',
                        }}
                    >
                        <span>
                            <strong>{this.get('@NewPatient.questionnaire.spacing')}:</strong>
                        </span>
                        <span>
                            {this.props.spacingAndCrowding.spacing.value === 'leaveSpecificSpaces' &&
                            this.props.spacingAndCrowding.spacing.location
                                ? `${spaceValue.label}: ${this.props.spacingAndCrowding.spacing.location}`
                                : (spaceValue?.expandingGridLabel ?? '')}
                        </span>
                        <span>
                            <strong>{this.get('@NewPatient.questionnaire.crowding')}:</strong>
                        </span>
                        <span>{isCrowdingAllFilled ? text : ''}</span>
                    </div>
                );
            case 'Q7':
                found = this.questions.overjet.options.find((opt) => opt.value === this.props.overJet.value);
                if (found.value === 'maintainInitialOverjet') {
                    return found.label;
                }
                const q7SubValueFound = found.options.find((opt) => opt.value === this.props.overJet.subValue);
                return (
                    <div>
                        <div>{found.label}</div>
                        <div>{q7SubValueFound.label}</div>
                    </div>
                );
            case 'Q8':
                found = this.questions.openbite.options.find((opt) => opt.value === this.props.openbite.value);
                if (found.value === 'maintainInitialOpenbite') return found.label;
                const q8SubValueFound = found.options.find((opt) => opt.value === this.props.openbite.subValue?.value);
                if (
                    q8SubValueFound &&
                    q8SubValueFound.value &&
                    q8SubValueFound.value === 'noPreferenceShowResultsInSimulator'
                ) {
                    return (
                        <div>
                            <div>{found.label}</div>
                            <div>{q8SubValueFound.label}</div>
                        </div>
                    );
                }
                const { extrudeAnteriorTeeth, intrudePosteriorTeeth, placeMiniImplantsTAD } =
                    this.props.openbite.subValue;
                let extrudeAnteriorTeethLabel = '';
                let intrudePosteriorTeethLabel = '';
                let placeMiniImplantsTADLabel = '';
                const subOpts = this.questions.openbite.options
                    .find((opt) => opt.value === 'improveResultingOpenbiteBy')
                    .options.filter((opt) => opt.value !== 'noPreferenceShowResultsInSimulator');
                for (let index = 0; index < subOpts.length; index++) {
                    const element = subOpts[index];
                    if (element.value === 'placeMiniImplantsTAD' && placeMiniImplantsTAD?.value === true) {
                        if (placeMiniImplantsTAD?.input) {
                            placeMiniImplantsTADLabel = `${element.label}: ${placeMiniImplantsTAD.input}`;
                        } else {
                            placeMiniImplantsTADLabel = element?.expandingGridLabel;
                        }
                    }
                    if (element.value === 'extrudeAnteriorTeeth' && extrudeAnteriorTeeth?.value === true) {
                        extrudeAnteriorTeethLabel += element.label;
                        if (extrudeAnteriorTeeth?.upper === true && extrudeAnteriorTeeth?.lower === true) {
                            extrudeAnteriorTeethLabel += `: ${this.getNotes('upper')}, ${this.getNotes('lower')}`;
                        } else if (extrudeAnteriorTeeth?.upper === true) {
                            extrudeAnteriorTeethLabel += `: ${this.getNotes('upper')}`;
                        } else if (extrudeAnteriorTeeth?.lower === true) {
                            extrudeAnteriorTeethLabel += `: ${this.getNotes('lower')}`;
                        }
                    }
                    if (element.value === 'intrudePosteriorTeeth' && intrudePosteriorTeeth?.value === true) {
                        intrudePosteriorTeethLabel += element.label;
                        if (intrudePosteriorTeeth?.upper === true && intrudePosteriorTeeth?.lower === true) {
                            intrudePosteriorTeethLabel += `: ${this.getNotes('upper')}, ${this.getNotes('lower')}`;
                        } else if (intrudePosteriorTeeth?.upper === true) {
                            intrudePosteriorTeethLabel += `: ${this.getNotes('upper')}`;
                        } else if (intrudePosteriorTeeth?.lower === true) {
                            intrudePosteriorTeethLabel += `: ${this.getNotes('lower')}`;
                        }
                    }
                }
                return (
                    <div>
                        <div>{found.label}</div>
                        {extrudeAnteriorTeethLabel.length > 0 && <div>{extrudeAnteriorTeethLabel}</div>}
                        {intrudePosteriorTeethLabel.length > 0 && <div>{intrudePosteriorTeethLabel}</div>}
                        {placeMiniImplantsTADLabel.length > 0 && <div>{placeMiniImplantsTADLabel}</div>}
                    </div>
                );
            case 'Q9':
                found = this.questions.deepBite.options.find((opt) => opt.value === this.props.deepBite.value);
                if (found.value === 'maintainExistingDeepBite') return found.label;
                const q9SubValueFound = found.options.find((opt) => opt.value === this.props.deepBite.subValue?.value);
                if (q9SubValueFound && q9SubValueFound.value && q9SubValueFound.value === 'noPreference') {
                    return (
                        <div>
                            <div>{found.label}</div>
                            <div>{q9SubValueFound.label}</div>
                        </div>
                    );
                }
                const { intrudeAnteriorTeeth, extrudePosteriorTeeth } = this.props.deepBite.subValue;
                const placeMiniImplantsTADLabelValue = { ...this.props.deepBite.subValue.placeMiniImplantsTAD };
                let extrudePosteriorTeethLabel = '';
                let intrudeAnteriorTeethLabel = '';
                let placeMiniImplantsTADLabelDisplay = '';
                const subOpts9 = this.questions.deepBite.options
                    .find((opt) => opt.value === 'improveResultingDeepBiteBy')
                    .options.filter((opt) => opt.value !== 'noPreference');
                for (let index = 0; index < subOpts9.length; index++) {
                    const element = subOpts9[index];
                    if (element.value === 'placeMiniImplantsTAD' && placeMiniImplantsTADLabelValue?.value === true) {
                        if (placeMiniImplantsTADLabelValue?.input) {
                            placeMiniImplantsTADLabelDisplay = `${element.label}: ${placeMiniImplantsTADLabelValue.input}`;
                        } else {
                            placeMiniImplantsTADLabelDisplay = element?.expandingGridLabel;
                        }
                    }
                    if (element.value === 'extrudePosteriorTeeth' && extrudePosteriorTeeth?.value === true) {
                        extrudePosteriorTeethLabel += element.label;
                        if (extrudePosteriorTeeth?.upper === true && extrudePosteriorTeeth?.lower === true) {
                            extrudePosteriorTeethLabel += `: ${this.getNotes('upper')}, ${this.getNotes('lower')}`;
                        } else if (extrudePosteriorTeeth?.upper === true) {
                            extrudePosteriorTeethLabel += `: ${this.getNotes('upper')}`;
                        } else if (extrudePosteriorTeeth?.lower === true) {
                            extrudePosteriorTeethLabel += `: ${this.getNotes('lower')}`;
                        }
                    }
                    if (element.value === 'intrudeAnteriorTeeth' && intrudeAnteriorTeeth?.value === true) {
                        intrudeAnteriorTeethLabel += element.label;
                        if (intrudeAnteriorTeeth?.upper === true && intrudeAnteriorTeeth?.lower === true) {
                            intrudeAnteriorTeethLabel += `: ${this.getNotes('upper')}, ${this.getNotes('lower')}`;
                        } else if (intrudeAnteriorTeeth?.upper === true) {
                            intrudeAnteriorTeethLabel += `: ${this.getNotes('upper')}`;
                        } else if (intrudeAnteriorTeeth?.lower === true) {
                            intrudeAnteriorTeethLabel += `: ${this.getNotes('lower')}`;
                        }
                    }
                }
                return (
                    <div>
                        <div>{found.label}</div>
                        {extrudePosteriorTeethLabel.length > 0 && <div>{extrudePosteriorTeethLabel}</div>}
                        {intrudeAnteriorTeethLabel.length > 0 && <div>{intrudeAnteriorTeethLabel}</div>}
                        {placeMiniImplantsTADLabelDisplay.length > 0 && <div>{placeMiniImplantsTADLabelDisplay}</div>}
                    </div>
                );
            case 'Q10':
                found = this.questions.midline.options.find((opt) => opt.value === this.props.midline.value);
                if (found.value === 'maintainInitialMidline') return found.label;
                const q10SubValueFound = found.options.find((opt) => opt.value === this.props.midline?.subValue?.value);
                if (q10SubValueFound && q10SubValueFound.value && q10SubValueFound.value === 'noPreference') {
                    return (
                        <div>
                            <div>{found.label}</div>
                            <div>{q10SubValueFound.label}</div>
                        </div>
                    );
                }
                const { upper, lower } = this.props.midline.subValue;
                let upperLabel = '';
                let lowerLabel = '';
                if (upper?.checked === true) {
                    upperLabel += this.getNotes('upper');
                }
                if (lower?.checked === true) {
                    lowerLabel += this.getNotes('lower');
                }
                const q10SubOpts = this.questions.midline.options
                    .find((opt) => opt.value === 'improveResultingMidlineBy')
                    .options.filter((opt) => opt.options !== 'noPreference');
                for (let index = 0; index < q10SubOpts.length; index++) {
                    const element = q10SubOpts[index];
                    if (element.value === 'upper' && upper?.checked === true) {
                        let subLabel = element.options.find((opt) => opt.value === upper?.value);
                        upperLabel += `: ${subLabel ? subLabel.label : ''}`;
                    }
                    if (element.value === 'lower' && lower?.checked === true) {
                        let subLabel = element.options.find((opt) => opt.value === lower?.value);
                        lowerLabel += `: ${subLabel ? subLabel.label : ''}`;
                    }
                }
                return (
                    <div>
                        <div>{found.label}</div>
                        {upperLabel.length > 0 && <div>{upperLabel}</div>}
                        {lowerLabel.length > 0 && <div>{lowerLabel}</div>}
                    </div>
                );
            case 'Q11':
                found = this.questions.posteriorCrossbite.options.find(
                    (opt) => opt.value === this.props.posteriorCrossbite.value
                );
                if (found.value === 'maintainInitialCrossbite') {
                    const text = found.expandingGridLabel;
                    return text;
                }
                const q11SubValueFound = found.options.find(
                    (opt) => opt.value === this.props.posteriorCrossbite.subValue?.value
                );
                if (
                    q11SubValueFound &&
                    q11SubValueFound.value &&
                    q11SubValueFound.value === 'noPreferenceShowResultsInSimulator'
                ) {
                    return (
                        <div>
                            <div>{found.expandingGridLabel}</div>
                            <div>{q11SubValueFound.label}</div>
                        </div>
                    );
                }
                const subOpts11 = this.questions.posteriorCrossbite.options
                    .find((opt) => opt.value === 'correct')
                    .options.filter((opt) => opt.value !== 'noPreferenceShowResultsInSimulator');
                let subOpt11Label = '';
                for (let index = 0; index < subOpts11.length; index++) {
                    const element = subOpts11[index];
                    const targetValue = this.props.posteriorCrossbite?.subValue?.value;
                    if (targetValue === element.value) {
                        if (element.value === 'interarchElastics') {
                            const displayValue = this.props.posteriorCrossbite?.subValue?.subValue?.value;
                            const displayValueFound = element.options.find((opt) => opt.value === displayValue);
                            const { buttonPressedDirectlyOnAligner, cutoutToBondButtonDirectlyOnTeeth } =
                                this.props.posteriorCrossbite?.subValue?.subValue;
                            if (
                                buttonPressedDirectlyOnAligner?.mandibularTeeth === true ||
                                buttonPressedDirectlyOnAligner?.maxillaryTeeth === true
                            ) {
                                if (buttonPressedDirectlyOnAligner?.mandibularTeeth === true) {
                                    subOpt11Label += this.getNotes('mandibularTeeth');
                                }
                                if (buttonPressedDirectlyOnAligner?.maxillaryTeeth === true) {
                                    if (subOpt11Label.length > 0) {
                                        subOpt11Label += `, ${this.getNotes('maxillaryTeeth')}`;
                                    } else {
                                        subOpt11Label += this.getNotes('maxillaryTeeth');
                                    }
                                }
                                return (
                                    <div>
                                        <div>{found.expandingGridLabel}</div>
                                        <div>
                                            {displayValueFound.label}: {subOpt11Label.length > 0 ? subOpt11Label : ''}
                                        </div>
                                    </div>
                                );
                            }
                            if (
                                cutoutToBondButtonDirectlyOnTeeth?.mandibularTeeth === true ||
                                cutoutToBondButtonDirectlyOnTeeth?.maxillaryTeeth === true
                            ) {
                                if (cutoutToBondButtonDirectlyOnTeeth?.mandibularTeeth === true) {
                                    subOpt11Label += this.getNotes('mandibularTeeth');
                                }
                                if (cutoutToBondButtonDirectlyOnTeeth?.maxillaryTeeth === true) {
                                    if (subOpt11Label.length > 0) {
                                        subOpt11Label += `, ${this.getNotes('maxillaryTeeth')}`;
                                    } else {
                                        subOpt11Label += this.getNotes('maxillaryTeeth');
                                    }
                                }
                                return (
                                    <div>
                                        <div>{found.expandingGridLabel}</div>
                                        <div>
                                            {displayValueFound.label}: {subOpt11Label.length > 0 ? subOpt11Label : ''}
                                        </div>
                                    </div>
                                );
                            }
                        }
                        if (element.value === 'noElastics') {
                            return (
                                <div>
                                    <div>{found.expandingGridLabel}</div>
                                    <div>{element.label}</div>
                                </div>
                            );
                        }
                        if (element.value === 'otherMethods') {
                            let text = found.expandingGridLabel;
                            if (this.props.posteriorCrossbite?.subValue?.subValue?.otherMethod) {
                                text = `${element.label}: ${this.props.posteriorCrossbite.subValue.subValue.otherMethod}`;
                            }
                            return (
                                <div>
                                    <div>{text}</div>
                                </div>
                            );
                        }
                    }
                }
                return found.label;
            case 'Q12':
                const handleAuxiliariesSubValue = () => {
                    const { upper, lower } = this.props.auxiliaries?.subValue;
                    const upperTargetValue = upper?.value;
                    const lowerTargetValue = lower?.value;
                    let upperOpt = undefined;
                    let lowerOpt = undefined;
                    let upperLabel = '';
                    let lowerLabel = '';
                    const elasticEngagementPreferenceQuestion = this.questions.auxiliaries.options
                        .find((opt) => opt.value === 'elastics')
                        .options.find((subOpt) => subOpt.value === 'elasticEngagementPreference');
                    if (elasticEngagementPreferenceQuestion) {
                        upperOpt = elasticEngagementPreferenceQuestion.options.find((opt) => opt.value === 'upper');
                        lowerOpt = elasticEngagementPreferenceQuestion.options.find((opt) => opt.value === 'lower');
                        if (upperOpt) {
                            if (upperOpt?.options && Array.isArray(upperOpt?.options)) {
                                const upperFound = upperOpt?.options.find((opt) => opt.value === upperTargetValue);
                                if (upperFound) upperLabel = upperFound.label;
                            }
                        }
                        if (lowerOpt) {
                            if (lowerOpt?.options && Array.isArray(lowerOpt?.options)) {
                                const lowerFound = lowerOpt?.options.find((opt) => opt.value === lowerTargetValue);
                                if (lowerFound) lowerLabel = lowerFound.label;
                            }
                        }
                    }
                    return { upperLabel, lowerLabel };
                };
                const getQ12Grid = (field = '') => {
                    if (['classIIElastics', 'classIIIElastics'].includes(field)) {
                        let targetValue = this.props.auxiliaries[field];

                        let displayText;
                        switch (targetValue) {
                            case 'No':
                                displayText = this.getNotes('No');
                                break;
                            case 'Yes':
                                displayText = this.getNotes('Yes');
                                break;
                            default:
                                displayText = '';
                        }
                        const { upperLabel, lowerLabel } = handleAuxiliariesSubValue();

                        return (
                            <div>
                                <div>
                                    {this.getNotes(field)} : {displayText}
                                </div>
                                {targetValue === 'Yes' && (
                                    <>
                                        <div>
                                            {this.getNotes('upperDentition')}: {upperLabel}
                                        </div>
                                        <div>
                                            {this.getNotes('lowerDentition')}: {lowerLabel}
                                        </div>
                                    </>
                                )}
                            </div>
                        );
                    }
                    if (field === 'otherElastics') {
                        const { otherElastics } = this.props.auxiliaries;
                        let displayText;
                        switch (otherElastics?.value) {
                            case 'No':
                                displayText = `${this.getNotes('otherElastics')} : ${this.getNotes('No')}`;
                                break;
                            case 'Yes':
                                if (otherElastics?.comment) {
                                    displayText = `${this.getNotes('otherElastics')}: ${otherElastics.comment}`;
                                } else {
                                    displayText = this.getNotes('otherElastics_v2');
                                }
                                break;
                            default:
                                displayText = `${this.getNotes('otherElastics')} :`;
                        }
                        return (
                            <div>
                                <div>{displayText}</div>
                            </div>
                        );
                    }
                };
                return (
                    <div>
                        <div>{this.getNotes('elastics')}</div>
                        <ol className={styles.expanding_grid_list}>
                            <li>
                                <div>{getQ12Grid('classIIElastics')}</div>
                            </li>
                            <li>
                                <div>{getQ12Grid('classIIIElastics')}</div>
                            </li>
                            <li>
                                <div>{getQ12Grid('otherElastics')}</div>
                            </li>
                        </ol>
                    </div>
                );
            case 'trioDimForce':
                found = this.questions.trioDimForce.options.find((opt) => opt.value === this.props.trioDimForce);
                if (found) return found.label;
                break;
            case 'restorativeOptions':
                found = this.questions.restorativeOptions.options.find(
                    (opt) => opt.value === this.props.restorativeOptions.value
                );
                if (found) {
                    if (found.value === 'No') return found.label;
                    let optLabel = found.value === 'No' ? found.label : this.getNotes('flowableInjection_short');
                    return (
                        <div>
                            <div>{optLabel}</div>
                            <div>{this.getNotes('referToDiagram')}</div>
                        </div>
                    );
                }
                break;
            case 'preImplantAligment':
                found = this.questions.preImplantAligment.options.find(
                    (opt) => opt.value === this.props.preImplantAligment.value
                );
                if (found) {
                    if (found.value === 'No') return found.label;
                    return `${found.label}. ${this.getNotes('referToDiagram')}`;
                }
                break;
            case 'addOnSmileDesign':
                found = this.questions.addOnSmileDesign.options.find(
                    (opt) => opt.value === this.props.addOnSmileDesign.value
                );
                if (found) return found.label;
                break;
            default:
                break;
        }
        return '';
    };

    getQuestionSubFieldError = (questionId) => {
        try {
            return this.computeQuestionSubFieldError(questionId);
        } catch (e) {
            return false;
        }
    };

    computeQuestionSubFieldError = (questionId) => {
        let isError = false;
        switch (questionId) {
            case 'Q3': {
                const isAttachmentErr =
                    this.props.attachments.value === 'includedExcludedAttachments' &&
                    this.props.attachments.doNotPlace.length === 0 &&
                    this.props.attachments.place.length === 0;
                const isDelayStageErr =
                    this.props.attachments.delay.value === 'delayToStage' && !this.props.attachments.delay.stage;
                isError = isAttachmentErr || isDelayStageErr;
                return isError;
            }
            case 'Q6': {
                const isSpacingErr =
                    this.props.spacingAndCrowding.spacing.value === 'leaveSpecificSpaces' &&
                    !this.props.spacingAndCrowding.spacing.location;
                isError = isSpacingErr;
                return isError;
            }
            case 'Q8': {
                const { extrudeAnteriorTeeth, intrudePosteriorTeeth, placeMiniImplantsTAD } =
                    this.props.openbite.subValue;
                const isExtrudeAnteriorTeethErr =
                    extrudeAnteriorTeeth?.value === true && !extrudeAnteriorTeeth.upper && !extrudeAnteriorTeeth.lower;
                const isIntrudePosteriorTeethErr =
                    intrudePosteriorTeeth?.value === true &&
                    !intrudePosteriorTeeth.upper &&
                    !intrudePosteriorTeeth.lower;
                const isPlaceMiniImplantsTADErr = placeMiniImplantsTAD?.value === true && !placeMiniImplantsTAD.input;
                isError = isExtrudeAnteriorTeethErr || isIntrudePosteriorTeethErr || isPlaceMiniImplantsTADErr;
                return isError;
            }
            case 'Q9': {
                const {
                    intrudeAnteriorTeeth,
                    extrudePosteriorTeeth,
                    placeMiniImplantsTAD: placeMiniImplantsTAD9,
                } = this.props.deepBite.subValue;
                const isIntrudeAnteriorTeethErr =
                    intrudeAnteriorTeeth?.value === true && !intrudeAnteriorTeeth.upper && !intrudeAnteriorTeeth.lower;
                const isExtrudePosteriorTeethErr =
                    extrudePosteriorTeeth?.value === true &&
                    !extrudePosteriorTeeth.upper &&
                    !extrudePosteriorTeeth.lower;
                const isPlaceMiniImplantsTADErr9 =
                    placeMiniImplantsTAD9?.value === true && !placeMiniImplantsTAD9.input;
                isError = isIntrudeAnteriorTeethErr || isExtrudePosteriorTeethErr || isPlaceMiniImplantsTADErr9;
                return isError;
            }
            case 'Q10': {
                const { upper, lower } = this.props.midline.subValue;
                const isUpperErr = upper?.checked === true && !upper.value;
                const isLowerErr = lower?.checked === true && !lower.value;
                isError = isUpperErr || isLowerErr;
                return isError;
            }
            case 'Q11': {
                const { buttonPressedDirectlyOnAligner, cutoutToBondButtonDirectlyOnTeeth, otherMethod } =
                    this.props.posteriorCrossbite?.subValue?.subValue || {};
                const isButtonPressedDirectlyOnAlignerErr =
                    this.props.posteriorCrossbite?.subValue?.subValue?.value === 'buttonPressedDirectlyOnAligner' &&
                    !buttonPressedDirectlyOnAligner?.mandibularTeeth &&
                    !buttonPressedDirectlyOnAligner?.maxillaryTeeth;
                const isCutoutToBondButtonDirectlyOnTeethErr =
                    this.props.posteriorCrossbite?.subValue?.subValue?.value === 'cutoutToBondButtonDirectlyOnTeeth' &&
                    !cutoutToBondButtonDirectlyOnTeeth?.mandibularTeeth &&
                    !cutoutToBondButtonDirectlyOnTeeth?.maxillaryTeeth;
                const isOtherMethodErr =
                    this.props.posteriorCrossbite?.subValue?.value === 'otherMethods' &&
                    (!otherMethod || otherMethod.length === 0);
                isError =
                    isButtonPressedDirectlyOnAlignerErr || isCutoutToBondButtonDirectlyOnTeethErr || isOtherMethodErr;
                return isError;
            }
            case 'Q12': {
                const { otherElastics } = this.props.auxiliaries;
                const isOtherElasticsErr =
                    otherElastics?.value === 'Yes' && (!otherElastics?.comment || !otherElastics?.comment?.length);
                isError = isOtherElasticsErr;
                return isError;
            }
            case 'restorativeOptions': {
                if (this.props.restorativeOptions.value === 'No') return false;
                const { onlayPosition, verticalDimension } = this.props.restorativeOptions.subValue;
                const { verticalDimensionUpperPosterior, verticalDimensionLowerPosterior } = verticalDimension;
                if (!onlayPosition || !onlayPosition.length) return true;
                const isUpperPosteriorInvalid =
                    !verticalDimensionUpperPosterior || !verticalDimensionUpperPosterior?.length;
                const isLowerPosteriorInvalid =
                    !verticalDimensionLowerPosterior || !verticalDimensionLowerPosterior?.length;
                if (isUpperPosteriorInvalid && isLowerPosteriorInvalid) return true;
                return false;
            }
            case 'preImplantAligment': {
                if (this.props.preImplantAligment.value === 'No') return false;
                if (
                    !this.props.preImplantAligment.prostheticSpace ||
                    !this.props.preImplantAligment.prostheticSpace.length
                )
                    return true;
                return false;
            }
            default:
                return isError;
        }
    };

    getIsQuestionError = (questionId) => {
        if (!this.props.prescriptionError) return false;
        let isError = false;
        switch (questionId) {
            case 'Q3':
                const isAttachmentErr =
                    this.props.attachments.value === 'includedExcludedAttachments' &&
                    this.props.attachments.doNotPlace.length === 0 &&
                    this.props.attachments.place.length === 0;
                const isDelayStageErr =
                    this.props.attachments.delay.value === 'delayToStage' && !this.props.attachments.delay.stage;
                isError = isAttachmentErr || isDelayStageErr;
                return isError;
            case 'Q6':
                const isSpacingErr =
                    this.props.spacingAndCrowding.spacing.value === 'leaveSpecificSpaces' &&
                    !this.props.spacingAndCrowding.spacing.location;
                isError = isSpacingErr;
                return isError;
            case 'Q8':
                const { extrudeAnteriorTeeth, intrudePosteriorTeeth, placeMiniImplantsTAD } =
                    this.props.openbite.subValue;
                const isExtrudeAnteriorTeethErr =
                    extrudeAnteriorTeeth?.value === true && !extrudeAnteriorTeeth.upper && !extrudeAnteriorTeeth.lower;
                const isIntrudePosteriorTeethErr =
                    intrudePosteriorTeeth?.value === true &&
                    !intrudePosteriorTeeth.upper &&
                    !intrudePosteriorTeeth.lower;
                const isPlaceMiniImplantsTADErr = placeMiniImplantsTAD?.value === true && !placeMiniImplantsTAD.input;
                isError = isExtrudeAnteriorTeethErr || isIntrudePosteriorTeethErr || isPlaceMiniImplantsTADErr;
                return isError;
            case 'Q9':
                const {
                    intrudeAnteriorTeeth,
                    extrudePosteriorTeeth,
                    placeMiniImplantsTAD: placeMiniImplantsTAD9,
                } = this.props.deepBite.subValue;
                const isIntrudeAnteriorTeethErr =
                    intrudeAnteriorTeeth?.value === true && !intrudeAnteriorTeeth.upper && !intrudeAnteriorTeeth.lower;
                const isExtrudePosteriorTeethErr =
                    extrudePosteriorTeeth?.value === true &&
                    !extrudePosteriorTeeth.upper &&
                    !extrudePosteriorTeeth.lower;
                const isPlaceMiniImplantsTADErr9 =
                    placeMiniImplantsTAD9?.value === true && !placeMiniImplantsTAD9.input;
                isError = isIntrudeAnteriorTeethErr || isExtrudePosteriorTeethErr || isPlaceMiniImplantsTADErr9;
                return isError;
            case 'Q10':
                const { upper, lower } = this.props.midline.subValue;
                const isUpperErr = upper?.checked === true && !upper.value;
                const isLowerErr = lower?.checked === true && !lower.value;
                isError = isUpperErr || isLowerErr;
                return isError;
            case 'Q11':
                const { buttonPressedDirectlyOnAligner, cutoutToBondButtonDirectlyOnTeeth, otherMethod } =
                    this.props.posteriorCrossbite?.subValue?.subValue || {};
                const isButtonPressedDirectlyOnAlignerErr =
                    this.props.posteriorCrossbite?.subValue?.subValue?.value === 'buttonPressedDirectlyOnAligner' &&
                    !buttonPressedDirectlyOnAligner?.mandibularTeeth &&
                    !buttonPressedDirectlyOnAligner?.maxillaryTeeth;
                const isCutoutToBondButtonDirectlyOnTeethErr =
                    this.props.posteriorCrossbite?.subValue?.subValue?.value === 'cutoutToBondButtonDirectlyOnTeeth' &&
                    !cutoutToBondButtonDirectlyOnTeeth?.mandibularTeeth &&
                    !cutoutToBondButtonDirectlyOnTeeth?.maxillaryTeeth;
                const isOtherMethodErr =
                    this.props.posteriorCrossbite?.subValue?.value === 'otherMethods' &&
                    (!otherMethod || otherMethod.length === 0);
                isError =
                    isButtonPressedDirectlyOnAlignerErr || isCutoutToBondButtonDirectlyOnTeethErr || isOtherMethodErr;
                return isError;
            case 'Q12':
                const { otherElastics } = this.props.auxiliaries;
                const isOtherElasticsErr =
                    otherElastics?.value === 'Yes' && (!otherElastics?.comment || !otherElastics?.comment?.length);
                isError = isOtherElasticsErr;
                return isError;
            case 'restorativeOptions':
                if (this.props.restorativeOptions.value === 'No') return false;
                const { onlayPosition, verticalDimension } = this.props.restorativeOptions.subValue;
                const { verticalDimensionUpperPosterior, verticalDimensionLowerPosterior } = verticalDimension;
                if (!onlayPosition || !onlayPosition.length) return true;
                const isUpperPosteriorInvalid =
                    !verticalDimensionUpperPosterior || !verticalDimensionUpperPosterior?.length;
                const isLowerPosteriorInvalid =
                    !verticalDimensionLowerPosterior || !verticalDimensionLowerPosterior?.length;
                if (isUpperPosteriorInvalid && isLowerPosteriorInvalid) return true;
                return false;
            case 'preImplantAligment':
                if (this.props.preImplantAligment.value === 'No') return false;
                if (
                    !this.props.preImplantAligment.prostheticSpace ||
                    !this.props.preImplantAligment.prostheticSpace.length
                )
                    return true;
                return false;
            default:
                return isError;
        }
    };

    getIsQuestionAnswered = (questionId) => {
        switch (questionId) {
            case 'Q1':
                if (this.props.formType === FORM_TYPE.REFINEMENT) {
                    if (this.props.archToTreat === 'both') {
                        return this.props.archToTreatStep?.upper != null && this.props.archToTreatStep?.lower != null;
                    } else if (this.props.archToTreat === 'archToTreatUpper') {
                        return this.props.archToTreatStep?.upper != null;
                    } else if (this.props.archToTreat === 'archToTreatLower') {
                        return this.props.archToTreatStep?.lower != null;
                    }
                }
                return this.props.archToTreat != null;
            case 'Q2':
                return true; // Optional question
            case 'Q3':
                return (
                    this.props.attachments.value != null &&
                    this.props.attachments.delay.value != null &&
                    (this.props.attachments.delay.value === 'delayToStage'
                        ? !!this.props.attachments.delay.stage
                        : true)
                );
            case 'Q4':
                return this.props.alignersMarginPlacement != null;
            case 'Q5':
                return (
                    this.props.anteriorPosteriorRelationship.l != null &&
                    this.props.anteriorPosteriorRelationship.r != null &&
                    this.props.anteriorPosteriorRelationship.l !== 'improveRelationship' &&
                    this.props.anteriorPosteriorRelationship.r !== 'improveRelationship'
                );
            case 'Q6':
                return (
                    this.props.spacingAndCrowding.spacing.value != null &&
                    (this.props.spacingAndCrowding.spacing.value === 'leaveSpecificSpaces'
                        ? !!this.props.spacingAndCrowding.spacing.location
                        : true) &&
                    !Object.values(this.props.spacingAndCrowding.crowding.resolveUpper).some(
                        (field) => field.value == null
                    ) &&
                    !Object.values(this.props.spacingAndCrowding.crowding.resolveLower).some(
                        (field) => field.value == null
                    )
                );
            case 'Q7':
                return this.props.overJet.value != null;
            case 'Q8':
                return this.props.openbite.value != null;
            case 'Q9':
                return this.props.deepBite.value != null;
            case 'Q10':
                return this.props.midline.value != null;
            case 'Q11':
                return this.props.posteriorCrossbite.value != null;
            case 'Q12':
                const otherElasticsAnswer = this.props.auxiliaries.otherElastics;
                const isOtherElasticsComplete =
                    otherElasticsAnswer?.value === 'No' ||
                    (otherElasticsAnswer?.value === 'Yes' && otherElasticsAnswer?.comment);

                return (
                    this.props.auxiliaries.classIIElastics != null &&
                    this.props.auxiliaries.classIIIElastics != null &&
                    otherElasticsAnswer.value != null &&
                    isOtherElasticsComplete
                );
            case 'trioDimForce':
                return this.props.trioDimForce != null;
            case 'restorativeOptions': {
                const ro = this.props.restorativeOptions;
                if (ro?.value == null) return false;
                if (ro.value === 'No') return true;
                const { onlayPosition, verticalDimension } = ro.subValue || {};
                if (!Array.isArray(onlayPosition) || onlayPosition.length === 0) return false;
                const { verticalDimensionUpperPosterior, verticalDimensionLowerPosterior } = verticalDimension || {};
                const hasUpper = !!(verticalDimensionUpperPosterior && verticalDimensionUpperPosterior.length);
                const hasLower = !!(verticalDimensionLowerPosterior && verticalDimensionLowerPosterior.length);
                return hasUpper || hasLower;
            }
            case 'preImplantAligment':
                return this.props.preImplantAligment.value != null;
            case 'addOnSmileDesign':
                return this.props.addOnSmileDesign.value != null;
            default:
                return false;
        }
    };

    render() {
        const { formType } = this.props;
        const answeredStatus = {
            Q1:
                this.props.formType === FORM_TYPE.REFINEMENT
                    ? this.props.archToTreat === 'both'
                        ? this.props.archToTreatStep?.upper != null && this.props.archToTreatStep?.lower != null
                        : this.props.archToTreat === 'archToTreatUpper'
                          ? this.props.archToTreatStep?.upper != null
                          : this.props.archToTreat === 'archToTreatLower'
                            ? this.props.archToTreatStep?.lower != null
                            : false
                    : this.props.archToTreat != null,
            Q2: true,
            Q3:
                this.props.attachments.value != null &&
                this.props.attachments.delay.value != null &&
                (this.props.attachments.delay.value === 'delayToStage' ? !!this.props.attachments.delay.stage : true) &&
                !this.getQuestionSubFieldError('Q3'),
            Q4: this.props.alignersMarginPlacement != null,
            Q5:
                this.props.anteriorPosteriorRelationship.l != null &&
                this.props.anteriorPosteriorRelationship.r != null &&
                this.props.anteriorPosteriorRelationship.l !== 'improveRelationship' &&
                this.props.anteriorPosteriorRelationship.r !== 'improveRelationship',
            Q6:
                this.props.spacingAndCrowding.spacing.value != null &&
                (this.props.spacingAndCrowding.spacing.value === 'leaveSpecificSpaces'
                    ? !!this.props.spacingAndCrowding.spacing.location
                    : true) &&
                !Object.values(this.props.spacingAndCrowding.crowding.resolveUpper).some(
                    (field) => field.value == null
                ) &&
                !Object.values(this.props.spacingAndCrowding.crowding.resolveLower).some(
                    (field) => field.value == null
                ),
            Q7: this.props.overJet.value != null,
            Q8: this.props.openbite.value != null && !this.getQuestionSubFieldError('Q8'),
            Q9: this.props.deepBite.value != null && !this.getQuestionSubFieldError('Q9'),
            Q10: this.props.midline.value != null && !this.getQuestionSubFieldError('Q10'),
            Q11: this.props.posteriorCrossbite.value != null && !this.getQuestionSubFieldError('Q11'),
            Q12:
                this.props.auxiliaries.classIIElastics != null &&
                this.props.auxiliaries.classIIIElastics != null &&
                this.props.auxiliaries.otherElastics.value != null &&
                (this.props.auxiliaries.otherElastics.value === 'No' ||
                    (this.props.auxiliaries.otherElastics.value === 'Yes' &&
                        this.props.auxiliaries.otherElastics.comment)),
            trioDimForce: this.props.trioDimForce != null,
            restorativeOptions: this.props.restorativeOptions.value != null,
            preImplantAligment:
                this.props.preImplantAligment.value != null && !this.getQuestionSubFieldError('preImplantAligment'),
            addOnSmileDesign: this.props.addOnSmileDesign.value != null,
        };
        return (
            <FormGroup>
                <NewErrorMessageDialog
                    title={this.get('@global.const.actionRequired')}
                    open={this.state.dialogOpen}
                    setOpen={this.handleDialog}
                    onClose={() => {
                        this.handleDialog();
                        setTimeout(() => {
                            this.handleClickScroll(this.props.prescriptionScrollToId);
                        }, 500);

                        if (this.props.prescriptionError === this.getWarning('elastic')) {
                            this.changeState('errorFrom', '');
                        }
                    }}
                    onOk={() => {
                        this.handleDialog();
                        setTimeout(() => {
                            this.handleClickScroll(this.props.prescriptionScrollToId);
                        }, 500);

                        if (this.props.prescriptionError === this.getWarning('elastic')) {
                            this.changeState('errorFrom', '');
                        }
                    }}
                    backgroundColor="#593687"
                >
                    <p>
                        {this.props.prescriptionError === this.getWarning('elastic_v2')
                            ? this.props.prescriptionError
                            : this.get('@NewPatient.warning.prescription_notes')}
                    </p>
                </NewErrorMessageDialog>
                <TrioDimDialog
                    open={this.state.trioDimModalOpen}
                    handleClose={() => this.setState({ trioDimModalOpen: false })}
                />
                <ExpandingModal
                    onClose={() => this.setState({ expandingModalOpen: false, expandingModalChildren: null })}
                    open={this.state.expandingModalOpen}
                    childrenFunc={this.state.expandingModalChildrenFunc}
                />
                <SmileDesignReportDialog
                    open={this.state.smileDesignReportModalOpen}
                    handleClose={() => this.setState({ smileDesignReportModalOpen: false })}
                />
                <ol className={styles.list}>
                    <ExpandingGrid
                        isRequired
                        questionId={'Q1'}
                        title={this.getNotes('archToTreat')}
                        expandable
                        isAnswered={answeredStatus.Q1}
                        showErrorBorder={this.props.prescriptionErrorQuestion === 18 && !answeredStatus.Q1}
                        children={this.getExpandingGridValueDisplay('Q1')}
                        openExpand={() => this.handleExpandingModalOpen('Q1')}
                    />
                    <ExpandingGrid
                        isRequired
                        title={
                            localStorage.lang === 'English' || localStorage.lang === 'en' ? (
                                <span>
                                    {this.getNotes('excludedDentition').split('NOT')[0]}
                                    <span className={[styles.redText, styles.underline].join(' ')}>NOT</span>
                                    {this.getNotes('excludedDentition').split('NOT')[1]}
                                </span>
                            ) : (
                                <span id="Q2">{this.getNotes('excludedDentition')}</span>
                            )
                        }
                        children={
                            <span>
                                {this.props.notToTreat?.length > 0
                                    ? // ? `${this.getNotes('yes')}. ${this.getNotes('referToDiagram')}`
                                      this.getNotes('notMoveTeeth')
                                    : this.getNotes('moveTeethAsNeeded')}
                            </span>
                        }
                        questionId={'Q2'}
                        expandable={true}
                        isAnswered={answeredStatus.Q2}
                        openExpand={() => this.handleExpandingModalOpen('Q2')}
                    />

                    <ExpandingGrid
                        isRequired
                        title={this.questions.attachments.label}
                        expandable
                        questionId={'Q3'}
                        children={this.getExpandingGridValueDisplay('Q3')}
                        openExpand={() => this.handleExpandingModalOpen('Q3')}
                        isError={this.getIsQuestionError('Q3')}
                        isAnswered={answeredStatus.Q3}
                        showErrorBorder={
                            this.getQuestionSubFieldError('Q3') ||
                            ((this.props.prescriptionErrorQuestion === 1 ||
                                this.props.prescriptionErrorQuestion === 19) &&
                                !answeredStatus.Q3)
                        }
                    />

                    <ExpandingGrid
                        questionId={'Q4'}
                        title={this.questions.alignersMarginPlacement.label}
                        expandable
                        children={this.getExpandingGridValueDisplay('Q4')}
                        openExpand={() => this.handleExpandingModalOpen('Q4')}
                        isAnswered={answeredStatus.Q4}
                    />

                    <ExpandingGrid
                        isRequired
                        questionId={'Q5'}
                        title={this.questions.anteriorPosteriorRelationship.label}
                        children={this.getExpandingGridValueDisplay('Q5')}
                        expandable={true}
                        openExpand={() => this.handleExpandingModalOpen('Q5')}
                        isAnswered={answeredStatus.Q5}
                        showErrorBorder={this.props.prescriptionErrorQuestion === 20 && !answeredStatus.Q5}
                    />

                    <ExpandingGrid
                        isRequired
                        questionId={'Q6'}
                        title={this.questions.spacingAndCrowding.label}
                        expandable
                        children={this.getExpandingGridValueDisplay('Q6')}
                        openExpand={() => this.handleExpandingModalOpen('Q6')}
                        isError={this.getIsQuestionError('Q6')}
                        isAnswered={answeredStatus.Q6}
                        showErrorBorder={
                            (this.props.prescriptionErrorQuestion === 4 ||
                                this.props.prescriptionErrorQuestion === 21) &&
                            !answeredStatus.Q6
                        }
                    />

                    <ExpandingGrid
                        questionId={'Q7'}
                        title={this.questions.overjet.label}
                        expandable
                        children={this.getExpandingGridValueDisplay('Q7')}
                        openExpand={() => this.handleExpandingModalOpen('Q7')}
                        isAnswered={answeredStatus.Q7}
                    />
                    <ExpandingGrid
                        questionId={'Q8'}
                        title={this.questions.openbite.label}
                        expandable
                        children={this.getExpandingGridValueDisplay('Q8')}
                        openExpand={() => this.handleExpandingModalOpen('Q8')}
                        isError={this.getIsQuestionError('Q8')}
                        isAnswered={answeredStatus.Q8}
                        showErrorBorder={this.getQuestionSubFieldError('Q8')}
                    />

                    <ExpandingGrid
                        questionId={'Q9'}
                        title={this.questions.deepBite.label}
                        expandable
                        children={this.getExpandingGridValueDisplay('Q9')}
                        openExpand={() => this.handleExpandingModalOpen('Q9')}
                        isError={this.getIsQuestionError('Q9')}
                        isAnswered={answeredStatus.Q9}
                        showErrorBorder={this.getQuestionSubFieldError('Q9')}
                    />

                    <ExpandingGrid
                        questionId={'Q10'}
                        title={this.questions.midline.label}
                        expandable
                        children={this.getExpandingGridValueDisplay('Q10')}
                        openExpand={() => this.handleExpandingModalOpen('Q10')}
                        isError={this.getIsQuestionError('Q10')}
                        isAnswered={answeredStatus.Q10}
                        showErrorBorder={this.getQuestionSubFieldError('Q10')}
                    />

                    <ExpandingGrid
                        questionId={'Q11'}
                        title={this.questions.posteriorCrossbite.label}
                        expandable
                        children={this.getExpandingGridValueDisplay('Q11')}
                        openExpand={() => this.handleExpandingModalOpen('Q11')}
                        isError={this.getIsQuestionError('Q11')}
                        isAnswered={answeredStatus.Q11}
                        showErrorBorder={this.getQuestionSubFieldError('Q11')}
                    />

                    <ExpandingGrid
                        isRequired
                        questionId={'Q12'}
                        title={this.questions.auxiliaries.label}
                        expandable
                        children={this.getExpandingGridValueDisplay('Q12')}
                        openExpand={() => this.handleExpandingModalOpen('Q12')}
                        isError={this.getIsQuestionError('Q12')}
                        isAnswered={answeredStatus.Q12}
                        showErrorBorder={
                            (this.props.prescriptionErrorQuestion === 22 ||
                                this.props.prescriptionErrorQuestion === 14) &&
                            !answeredStatus.Q12
                        }
                    />

                    <ExpandingGrid
                        questionId={'trioDimForce'}
                        title={
                            <>
                                {this.questions.trioDimForce.label}
                                <button
                                    className={styles.trio_dim_learn_more}
                                    onClick={() => this.setState({ trioDimModalOpen: true })}
                                >
                                    {this.getNotes('learnMore')}
                                </button>
                            </>
                        }
                        expandable
                        children={this.getExpandingGridValueDisplay('trioDimForce')}
                        openExpand={() => this.handleExpandingModalOpen('trioDimForce')}
                        isError={false}
                        isAnswered={this.getIsQuestionAnswered('trioDimForce')}
                    />

                    {this.isShowUpsellForm() && (
                        <>
                            <ExpandingGrid
                                questionId={'restorativeOptions'}
                                title={
                                    <div>
                                        {this.getNotes('restorativeOptions')}
                                        <div>{this.getNotes('additionalFee')}</div>
                                    </div>
                                }
                                expandable
                                children={this.getExpandingGridValueDisplay('restorativeOptions')}
                                openExpand={() => this.handleExpandingModalOpen('restorativeOptions')}
                                isError={this.getIsQuestionError('restorativeOptions')}
                                isAnswered={this.getIsQuestionAnswered('restorativeOptions')}
                                showErrorBorder={!this.getIsQuestionAnswered('restorativeOptions')}
                            />

                            <ExpandingGrid
                                questionId={'preImplantAligment'}
                                title={this.getNotes('preImplantAligment')}
                                expandable
                                children={this.getExpandingGridValueDisplay('preImplantAligment')}
                                openExpand={() => this.handleExpandingModalOpen('preImplantAligment')}
                                isError={this.getIsQuestionError('preImplantAligment')}
                                isAnswered={this.getIsQuestionAnswered('preImplantAligment')}
                                showErrorBorder={this.getQuestionSubFieldError('preImplantAligment')}
                            />

                            <ExpandingGrid
                                questionId={'addOnSmileDesign'}
                                title={
                                    <div>
                                        {this.getNotes('addOnSmileDesign')}
                                        <button
                                            className={styles.trio_dim_learn_more}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.setState({ smileDesignReportModalOpen: true });
                                            }}
                                        >
                                            {this.getNotes('learnMore')}
                                        </button>
                                        <div>{this.getNotes('additionalFee')}</div>
                                    </div>
                                }
                                expandable
                                children={this.getExpandingGridValueDisplay('addOnSmileDesign')}
                                openExpand={() => this.handleExpandingModalOpen('addOnSmileDesign')}
                                isAnswered={this.getIsQuestionAnswered('addOnSmileDesign')}
                            />
                        </>
                    )}
                    <ExpandingGrid
                        questionId={'Q17TextField'}
                        title={this.questions.additionalInstructionsOrSpecialRequests.label}
                        children={
                            <TextField
                                id="Q17TextField"
                                className={styles.specialInstructionsField}
                                placeholder={this.getNotes('additionalInstructionsOrSpecialRequestsPlaceholder')}
                                defaultValue={this.props.specialInstructions}
                                onBlur={(e) => {
                                    this.props.handleSpecialInstructions(e.target.value);
                                }}
                                variant="outlined"
                                margin="normal"
                                multiline
                                rows={4}
                                inputProps={{
                                    style: { color: 'black' },
                                    onClick: () => {
                                        if (!this.validation('specialInstructions')) {
                                            document.getElementById('Q14TextField').blur();
                                        }
                                    },
                                }}
                                disabled={this.props.mode === 'view'}
                                ref={this.specialInstructionsRef}
                            />
                        }
                    />
                    <p style={{marginLeft:'-30px'}}>{this.getNotes('additionalInstructionsOrSpecialRequestsRemark')}</p>
                </ol>
            </FormGroup>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        archToTreat: store.newPatientReducer.archToTreat,
        archToTreatStep: {
            upper: store.newPatientReducer.archToTreatUpperStep,
            lower: store.newPatientReducer.archToTreatLowerStep,
        },
        notToTreat: store.newPatientReducer.notToTreat1,
        attachments: store.newPatientReducer.attachments1,
        alignersMarginPlacement: store.newPatientReducer.alignersMarginPlacement1,
        anteriorPosteriorRelationship: store.newPatientReducer.anteriorPosteriorRelationship1,
        spacingAndCrowding: store.newPatientReducer.spacingAndCrowding1,
        overJet: store.newPatientReducer.overJet1,
        openbite: store.newPatientReducer.openbite1,
        deepBite: store.newPatientReducer.deepBite1,
        midline: store.newPatientReducer.midline1,
        posteriorCrossbite: store.newPatientReducer.posteriorCrossbite1,
        cuttingOptions: store.newPatientReducer.cuttingOptions1,
        auxiliaries: store.newPatientReducer.auxiliaries1,
        trioDimForce: store.newPatientReducer.trioDimForce,
        specialInstructions: store.newPatientReducer.specialInstructions1,
        prescriptionError: store.newPatientReducer.prescriptionError,
        prescriptionErrorQuestion: store.newPatientReducer.prescriptionErrorQuestion,
        prescriptionScrollToId: store.newPatientReducer.prescriptionScrollToId,
        prescriptionScroll: store.newPatientReducer.prescriptionScroll,
        lang: store.lang,
        restorativeOptions: store.newPatientReducer.restorativeOptions,
        preImplantAligment: store.newPatientReducer.preImplantAligment,
        addOnSmileDesign: store.newPatientReducer.addOnSmileDesign,
        userAllowedFeatures: store.userAllowedFeatures,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleDataArchToTreat: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_ARCH_TO_TREAT, value: value }),
        handleDataNotToTreat: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_NOT_TO_TREAT, value: value }),
        handleAttachements: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_ATTACHMENTS, value }),
        handleAttachementsClickPlace: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_ATTACHMENTS_PLACE, value }),
        handleAttachementsClickNotToPlace: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_ATTACHMENTS_NOT_PLACE, value }),
        handleAttachementsClickDelay: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_ATTACHMENTS_DELAY, value }),
        handleAttachementsClickDelayStage: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_ATTACHMENTS_DELAY_STAGE, value }),
        handleMarginPlacement: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_MARGIN_PLACEMENT, value }),
        handleApRelationships: (value, field) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_AP_RELATIONSHIPS, value, field }),
        handleSpacing: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_SPACING, value }),
        handleSpacingLocation: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_SPACING_LOCATION, value }),
        handleCrowding: (value, category, field) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_CROWDING, value, category, field }),
        handleCrowdingTeeth: (value, category, field) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_CROWDING_TEETH, value, category, field }),
        handleOverJet: (value, field) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_OVERJET, value, field }),
        handleOpenBite: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_OPEN_BITE, value }),
        handleOpenBiteImprove: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_OPEN_BITE_IMPROVE, value }),
        handleOpenBiteCheckBox: (field, category) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_OPEN_BITE_CHECKBOX, field, category: category || false }),
        handleOpenBiteText: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_OPEN_BITE_TEXT, value }),
        handleDeepBite: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_DEEP_BITE, value }),
        handleDeepBiteImprove: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_DEEP_BITE_IMPROVE, value }),
        handleDeepBiteCheckBox: (field, category) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_DEEP_BITE_CHECKBOX, field, category: category || false }),
        handleDeepBiteText: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_DEEP_BITE_TEXT, value }),
        handleMidline: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_MIDLINE, value }),
        handleMidlineImprove: (value, field) =>
            dispatch({
                type: actionTypes.NEW_PATIENT_PRES_MIDLINE_IMPROVE,
                field: field || false,
                value: value || false,
            }),
        handleMidlinePosition: (value, field) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_MIDLINE_POSITION, field, value }),
        handlePosteriorCrossbite: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_POSTERIOR_CROSSBITE, value }),
        handlePosteriorCrossbiteCorrect: (value, field) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_CORRECT, value, field: field || false }),
        handlePosteriorCrossbiteTeeth: (category, field) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_TEETH, field, category }),
        handlePosteriorCrossbiteOther: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_OTHER, value }),
        handleCuttingOptions: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_CUTTING_OPTIONS, value }),
        handleAuxiliaries: (field, value, category) =>
            dispatch({
                type: actionTypes.NEW_PATIENT_PRES_AUXILIARIES,
                field,
                value: value || false,
                category: category || false,
            }),
        handleAuxiliariesOther: (value, field) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_AUXILIARIES_OTHER_ELASTICS, value, field: field || false }),
        handleTrioDimForce: (value) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_TRIODIM_FORCE, value }),
        handleSpecialInstructions: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_SPECIAL_INSTRUCTIONS, value }),
        handlePrescriptionError: (error) => dispatch({ type: actionTypes.NEW_PATIENT_PRES_ERROR, error }),
        handlePrescriptionErrorQuestion: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_ERROR_QUESTION, value }),
        handlePrescriptionErrorScrollId: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_ERROR_SCROLL_ID, value }),
        handlePrescriptionErrorScroll: () => dispatch({ type: actionTypes.NEW_PATIENT_PRES_ERROR_SCROLL }),
        openGlobalModal: ({ modalTitle, modalMessage }) =>
            dispatch(
                openModal({
                    modalTitle: modalTitle || '',
                    modalMessage: modalMessage || '',
                    showOk: false,
                })
            ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLang(PrescriptionNotes, 'NewPatient')));
